<div class="contact-dialog-overlay" style="background-color: transparent;">
    <!-- Close button positioned outside the panel
    <button [attr.guide]="'lead-detail-panel-btn-1' + '__' + sanitizedUrl" mat-icon-button class="close-dialog-btn"
        (click)="dialogRef.close()">
        <mat-icon>close</mat-icon>
    </button> -->

    <div class="new-leadType-five" fxLayout="column" fxFlex>

        <div class="lead-detail-page" [fxLayout]="isDeal() ? 'row' : 'column'" fxFlex>
            <div class="profile-card" [fxFlex]="isDeal() ? '30' : 'none'"
                [ngStyle]="isDeal() ? {'flex-direction': 'column', 'align-items': 'stretch', 'height': '100%', 'overflow-y': 'auto', 'border-right': '1px solid #e2e8f0'} : {}">
                <!-- Left section -->
                <div class="profile-left">
                    <div class="profile-header" fxLayout="column" fxLayoutGap="10px">
                        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
                            <div class="avatar-container" (click)="openViewDialog()">
                                <!-- <img *ngIf="!imageError" [src]="basePath + LeadDetailsObject?.image + '&cid=' + cid"
                                alt="Profile Avatar" class="avatar-image" (error)="setError()" /> -->

                                <img *ngIf="LeadDetailsObject?.image; else initialAvatar" [src]="uploadedImageUrl"
                                    alt="Profile Avatar" class="avatar-image" />



                                <!-- If no image, show initials -->
                                <ng-template #initialAvatar>
                                    <div class="avatar-initial">
                                        {{ LeadDetailsObject?.name?.charAt(0) | uppercase }}
                                    </div>
                                </ng-template>

                                <!-- <div *ngIf="imageError" class="avatar-fallback">
                                {{ LeadDetailsObject?.name?.charAt(0) | uppercase }}
                            </div> -->

                                <div class="overlay">
                                    <div class="overlay-text"> {{ LeadDetailsObject?.image ? 'View' : 'Add' }}</div>
                                </div>
                            </div>
                            <div class="profile-info">
                                <div class="name-row" style="display:flex;align-items:center;gap:8px;">
                                    <h2 class="name" style="margin:0;">{{ LeadDetailsObject?.name }}</h2>
                                    <button [attr.guide]="'lead-detail-panel-btn-2' + '__' + sanitizedUrl"
                                        class="edit-btn" style="opacity: 1;margin-left: 5px;"
                                        (click)="openEditPopup('name', 'Name', 'text')">
                                        <mat-icon style="font-size: 16px; padding-top: 8px;">edit</mat-icon>
                                    </button>
                                </div>
                                <p class="title">{{ LeadDetailsObject?.jobTitle }}</p>
                                <div class="social-icons" *ngIf="!url.includes('deals') && !url.includes('type=deal')">

                                    <a [attr.guide]="'lead-detail-panel-lnk-3' + '__' + sanitizedUrl"
                                        (click)="openSocialUrl('facebook', $event)">
                                        <img [src]="LeadDetailsObject?.facebook 
              ? 'https://img.icons8.com/fluent/48/000000/facebook-new.png' 
              : 'https://img.icons8.com/ios/48/000000/facebook--v1.png'" />
                                    </a>


                                    <a [attr.guide]="'lead-detail-panel-lnk-4' + '__' + sanitizedUrl"
                                        (click)="openSocialUrl('twitter', $event)">
                                        <img [src]="LeadDetailsObject?.twitter 
              ? 'https://img.icons8.com/ios-filled/50/000000/x.png' 
              : 'https://img.icons8.com/ios-filled/50/000000/x.png'" />
                                    </a>


                                    <a [attr.guide]="'lead-detail-panel-lnk-5' + '__' + sanitizedUrl"
                                        (click)="openSocialUrl('linkedIn', $event)">
                                        <img [src]="LeadDetailsObject?.linkedIn 
              ? 'https://img.icons8.com/fluent/48/000000/linkedin.png' 
              : 'https://img.icons8.com/ios/48/000000/linkedin.png'" />
                                    </a>

                                    <a style="cursor: pointer; padding-left: 75px;" [matMenuTriggerFor]="socialMenu">
                                        <mat-icon style="color: black;">edit</mat-icon>
                                    </a>


                                </div>

                                <mat-menu #socialMenu="matMenu" class="social-menu" [hasBackdrop]="true">
                                    <form [formGroup]="firstFormGroup" class="social-form" style="padding:10px;">
                                        <mat-form-field appearance="outline" style="width: 100%;"
                                            (click)="$event.stopPropagation()">
                                            <mat-label>Facebook</mat-label>
                                            <input [attr.guide]="'lead-detail-panel-inp-facebook' + '__' + sanitizedUrl"
                                                matInput placeholder="Enter profile URL or username"
                                                formControlName="facebook" />
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" style="width: 100%;"
                                            (click)="$event.stopPropagation()">
                                            <mat-label>Twitter</mat-label>
                                            <input [attr.guide]="'lead-detail-panel-inp-twitter' + '__' + sanitizedUrl"
                                                matInput placeholder="Enter profile URL or username"
                                                formControlName="twitter" />
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" style="width: 100%;"
                                            (click)="$event.stopPropagation()">
                                            <mat-label>LinkedIn</mat-label>
                                            <input [attr.guide]="'lead-detail-panel-inp-linkedin' + '__' + sanitizedUrl"
                                                matInput placeholder="Enter profile URL or username"
                                                formControlName="linkedIn" />
                                        </mat-form-field>

                                        <div class="social-actions">
                                            <button [attr.guide]="'lead-detail-panel-btn-6' + '__' + sanitizedUrl"
                                                mat-button matMenuClose>Cancel</button>
                                            <button [attr.guide]="'lead-detail-panel-btn-7' + '__' + sanitizedUrl"
                                                mat-flat-button color="primary" (click)="editProfileUrl()"
                                                matMenuClose>Save</button>
                                        </div>
                                    </form>
                                </mat-menu>
                            </div>
                        </div>

                        <!-- Deal Profile Card Fields -->
                        <div *ngIf="isDeal()" class="deal-properties-grid"
                            style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px 16px; margin-top: 24px; width: 100%; box-sizing: border-box;">
                            <div class="prop-item" style="display: flex; flex-direction: column; font-size: 13px;">
                                <span class="prop-label"
                                    style="color: #64748b; font-weight: 500; margin-bottom: 2px;">Deal Name</span>
                                <span class="prop-value" style="color: #334155; font-weight: 600;">{{
                                    LeadDetailsObject?.dealsName || '--' }}</span>
                            </div>
                            <div class="prop-item" style="display: flex; flex-direction: column; font-size: 13px;">
                                <span class="prop-label"
                                    style="color: #64748b; font-weight: 500; margin-bottom: 2px;">Stage</span>
                                <span class="prop-value" style="color: #334155; font-weight: 600;">{{
                                    LeadDetailsObject?.stage || '--' }}</span>
                            </div>
                            <div class="prop-item" style="display: flex; flex-direction: column; font-size: 13px;">
                                <span class="prop-label"
                                    style="color: #64748b; font-weight: 500; margin-bottom: 2px;">Owner</span>
                                <span class="prop-value" style="color: #334155; font-weight: 600;">{{
                                    LeadDetailsObject?.dealsOwner || '--' }}</span>
                            </div>
                            <div class="prop-item" style="display: flex; flex-direction: column; font-size: 13px;">
                                <span class="prop-label"
                                    style="color: #64748b; font-weight: 500; margin-bottom: 2px;">Payment Status</span>
                                <span class="prop-value" style="color: #334155; font-weight: 600;">{{
                                    LeadDetailsObject?.paymentStatus || '--' }}</span>
                            </div>
                            <div class="prop-item" style="display: flex; flex-direction: column; font-size: 13px;">
                                <span class="prop-label"
                                    style="color: #64748b; font-weight: 500; margin-bottom: 2px;">Paid</span>
                                <span class="prop-value" style="color: #334155; font-weight: 600;">{{
                                    LeadDetailsObject?.paid || '--' }}</span>
                            </div>
                            <div class="prop-item" style="display: flex; flex-direction: column; font-size: 13px;">
                                <span class="prop-label"
                                    style="color: #64748b; font-weight: 500; margin-bottom: 2px;">Balance</span>
                                <span class="prop-value" style="color: #334155; font-weight: 600;">{{
                                    LeadDetailsObject?.balance || '--' }}</span>
                            </div>
                        </div>


                        <!-- <div class="profile-info">


                            <div class="flex items-center">
                                <p class="title  items-center gap-2"
                                    [style.cursor]="LeadDetailsObject?.company ? 'pointer' : 'not-allowed'"
                                    [style.pointerEvents]="!LeadDetailsObject?.company ? 'none' : 'auto'"
                                    [style.opacity]="!LeadDetailsObject?.company ? '0.6' : '1'">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;" class="primary-icon">
                                        corporate_fare
                                    </mat-icon>

                                    <span style="font-weight: bold;color: black;"
                                        (click)="LeadDetailsObject?.company ? companyDetailPage(LeadDetailsObject?.companyId) : null">
                                        {{ LeadDetailsObject?.company || '—' }}
                                    </span>
                                </p>

                                <button [attr.guide]="'lead-detail-panel-btn-8' + '__' + sanitizedUrl" class="edit-btn" style="opacity: 1;margin-left: 10px;"
                                    (click)="openEditPopup('company', 'Company', 'text'); $event.stopPropagation()">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;">edit</mat-icon>
                                </button>
                            </div>


                            <div class="flex items-center">
                                <p class="title  items-center gap-2"
                                    [style.cursor]="LeadDetailsObject?.jobtitle ? 'pointer' : 'not-allowed'"
                                    [style.pointerEvents]="!LeadDetailsObject?.jobtitle ? 'none' : 'auto'"
                                    [style.opacity]="!LeadDetailsObject?.jobtitle ? '0.6' : '1'">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;" class="primary-icon">
                                        work
                                    </mat-icon>

                                    <span>
                                        {{ LeadDetailsObject?.jobtitle || '—' }}
                                    </span>
                                </p>

                                <button [attr.guide]="'lead-detail-panel-btn-9' + '__' + sanitizedUrl" class="edit-btn" style="opacity: 1;margin-left: 10px;"
                                    (click)="openEditPopup('jobtitle', 'Jobtitle', 'text') ;$event.stopPropagation()">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;">edit</mat-icon>
                                </button>
                            </div>

                         
                            <div class="flex items-center">
                                <p class="title  items-center gap-2"
                                    [style.cursor]="LeadDetailsObject?.email ? 'pointer' : 'not-allowed'"
                                    [style.pointerEvents]="!LeadDetailsObject?.email ? 'none' : 'auto'"
                                    [style.opacity]="!LeadDetailsObject?.email ? '0.6' : '1'">
                                    <mat-icon (click)="LeadDetailsObject?.email ? openEmailPopup() : null"
                                        style="font-size: 16px; padding-top: 10px;" class="primary-icon">
                                        mail
                                    </mat-icon>

                                    <span style="word-break: break-all;" (click)="LeadDetailsObject?.email ? openEmailPopup() : null">
                                        {{ LeadDetailsObject?.email || '—' }}
                                    </span>

                                    <mat-icon *ngIf="LeadDetailsObject?.email"
                                        style="font-size: 16px; padding-top: 8px; margin-left: 10px;"
                                        class="cursor-pointer text-gray-500 hover:text-gray-700"
                                        (click)="LeadDetailsObject?.email ?   (LeadDetailsObject?.email) : null">
                                        content_copy
                                    </mat-icon>
                                </p>
                                <button [attr.guide]="'lead-detail-panel-btn-10' + '__' + sanitizedUrl" class="edit-btn" style="opacity: 1;margin-left: 5px;"
                                    (click)="openEditPopup('email', 'Email', 'text')">
                                    <mat-icon style="font-size: 16px; padding-top: 8px;">edit</mat-icon>
                                </button>
                            </div>

                            <div class="flex items-center">

                                <p class="title  items-center gap-2"
                                    [style.cursor]="LeadDetailsObject?.phoneNumber ? 'pointer' : 'not-allowed'"
                                    [style.pointerEvents]="!LeadDetailsObject?.phoneNumber ? 'none' : 'auto'"
                                    [style.opacity]="!LeadDetailsObject?.phoneNumber ? '0.6' : '1'">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;"
                                        class="primary-icon">call</mat-icon>

                                    <span
                                        (click)="LeadDetailsObject?.phoneNumber ? phoneNumbercall(LeadDetailsObject) : null">
                                        {{ LeadDetailsObject?.phoneNumber || '—' }}
                                    </span>
                                </p>

                           
                                <button [attr.guide]="'lead-detail-panel-btn-11' + '__' + sanitizedUrl" class="edit-btn title" style="opacity: 1;margin-left: 10px;"
                                    (click)="openEditPopup('phoneNumber', 'Phone Number', 'number'); $event.stopPropagation()">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;">edit</mat-icon>
                                </button>
                            </div>

                     
                            <div class="flex items-center">
                                <p class="title  items-center gap-2"
                                    [style.cursor]="LeadDetailsObject?.phoneNumber ? 'pointer' : 'not-allowed'"
                                    [style.pointerEvents]="!LeadDetailsObject?.phoneNumber ? 'none' : 'auto'"
                                    [style.opacity]="!LeadDetailsObject?.phoneNumber ? '0.6' : '1'">
                                    <mat-icon style="font-size: 16px; padding-top: 8px;" class="primary-icon"
                                        [icIcon]="icWhatsapp"></mat-icon>
                                    <span
                                        (click)="LeadDetailsObject?.phoneNumber ? phonewhatsapp(LeadDetailsObject) : null">
                                        {{ LeadDetailsObject?.phoneNumber || '—' }}
                                    </span>
                                </p>

                                <button [attr.guide]="'lead-detail-panel-btn-12' + '__' + sanitizedUrl" class="edit-btn title" style="opacity: 1;margin-left: 10px;"
                                    (click)="openEditPopup('phoneNumber', 'Phone Number', 'number')">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;">edit</mat-icon>
                                </button>
                            </div>

                           
                            <div class="flex items-center">
                                <p class="title  items-center gap-2"
                                    [style.cursor]="LeadDetailsObject?.ownerIdName ? 'pointer' : 'not-allowed'"
                                    [style.pointerEvents]="!LeadDetailsObject?.ownerIdName ? 'none' : 'auto'"
                                    [style.opacity]="!LeadDetailsObject?.ownerIdName ? '0.6' : '1'">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;" class="primary-icon">
                                        attribution
                                    </mat-icon>

                                   
                                    <span>
                                        {{ LeadDetailsObject?.ownerIdName || '—' }}
                                    </span>
                                </p>

                                <button [attr.guide]="'lead-detail-panel-btn-13' + '__' + sanitizedUrl" class="edit-btn title" style="opacity: 1;margin-left: 10px;"
                                    (click)="transferLead(); $event.stopPropagation()">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;">edit</mat-icon>
                                </button>
                            </div>

                            <div class="flex items-center">
                                <p class="title items-center gap-2"
                                    [style.cursor]="LeadDetailsObject?.statusName ? 'pointer' : 'not-allowed'"
                                    [style.pointerEvents]="!LeadDetailsObject?.statusName ? 'none' : 'auto'"
                                    [style.opacity]="!LeadDetailsObject?.statusName ? '0.6' : '1'">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;" class="primary-icon">
                                        info
                                    </mat-icon>                                  
                                    <span>
                                        {{ LeadDetailsObject?.statusName || '—' }}
                                    </span>
                                </p>

                                <button [attr.guide]="'lead-detail-panel-btn-14' + '__' + sanitizedUrl" class="edit-btn" style="opacity: 1; margin-left: 10px;"
                                    (click)="openEditPopup('statusName', 'Status Name', 'select'); $event.stopPropagation()">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;">edit</mat-icon>
                                </button>
                            </div>

                        </div> -->
                    </div>

                    <!-- Score goes here -->
                    <div class="score-card" *ngIf="!url.includes('deals') && !url.includes('type=deal')">
                        <div class="score-header"><span>Score</span></div>
                        <div class="score-content">
                            <h3 class="score-value">{{ LeadDetailsObject?.score || 0.0 }}</h3>
                            <div class="stars">
                                <ng-container *ngFor="let star of starsArray; let i = index">
                                    <span class="material-symbols-outlined" [ngClass]="{ 'fill': i < filledStars }">
                                        star
                                    </span>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Right section -->
                <div class="actions" *ngIf="!isDeal()">
                    <button [attr.guide]="'lead-detail-panel-btn-15' + '__' + sanitizedUrl" mat-stroked-button
                        color="primary" (click)="gotoLeadDetailPage()">See all details</button>
                    <div class="nav-arrows">
                        <button [attr.guide]="'lead-detail-panel-btn-16' + '__' + sanitizedUrl" mat-icon-button
                            (click)="goPrevious()" [disabled]="!allIds?.length || currentIndex <= 0">
                            <span class="material-symbols-outlined">chevron_left</span>
                        </button>

                        <button [attr.guide]="'lead-detail-panel-btn-17' + '__' + sanitizedUrl" mat-icon-button
                            (click)="goNext()" [disabled]="!allIds?.length || currentIndex >= allIds.length - 1">
                            <span class="material-symbols-outlined">chevron_right</span>
                        </button>

                        <!-- Close button placed at top right -->
                        <button mat-icon-button (click)="dialogRef.close()">
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>
                </div>
            </div>


            <div [fxFlex]="isDeal() ? '70' : 'none'" fxLayout="column"
                [ngStyle]="isDeal() ? {'height': '100%', 'overflow-y': 'auto', 'background-color': '#f2f5f8', 'width': '100%'} : {'width': '100%'}">
                <div class="header-container" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">

                    <!-- Left side of header -->
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" style="flex-wrap: wrap;">
                        <ng-container *ngIf="!url.includes('deals') && !url.includes('type=deal')">
                            <button [attr.guide]="'lead-detail-panel-btn-18' + '__' + sanitizedUrl" class="header-btn"
                                (click)="openEmailPopup()"><span class="material-symbols-outlined">email</span>
                                Email</button>
                            <button [attr.guide]="'lead-detail-panel-btn-19' + '__' + sanitizedUrl" class="header-btn"
                                (click)="phoneNumbercall(LeadDetailsObject)"><span
                                    class="material-symbols-outlined">call</span>
                                Call</button>
                            <!-- <button [attr.guide]="'lead-detail-panel-btn-20' + '__' + sanitizedUrl" class="header-btn"><span class="material-symbols-outlined">sms</span> SMS</button> -->
                            <button [attr.guide]="'lead-detail-panel-btn-21' + '__' + sanitizedUrl" class="header-btn"
                                (click)="addLeadActivity('Phone Call',0,null)"><span
                                    class="material-symbols-outlined">task</span>
                                Task</button>
                            <button [attr.guide]="'lead-detail-panel-btn-22' + '__' + sanitizedUrl" class="header-btn"
                                (click)="goToMeeting()"><span class="material-symbols-outlined">meeting_room</span>
                                Meeting</button>
                            <!-- <button [attr.guide]="'lead-detail-panel-btn-23' + '__' + sanitizedUrl" class="header-btn-secondary"><span class="material-symbols-outlined">sell</span> Sales
                        activities
                        <span class="material-symbols-outlined">arrow_drop_down</span></button> -->
                            <button [attr.guide]="'lead-detail-panel-btn-24' + '__' + sanitizedUrl"
                                class="header-btn-primary" (click)="goToDeals()"><span
                                    class="material-symbols-outlined">add</span> Add deal</button>
                        </ng-container>
                        <button [attr.guide]="'lead-detail-panel-btn-25' + '__' + sanitizedUrl" type="button"
                            class="header-btn" [matMenuTriggerFor]="actionsMenu" (click)="$event.stopPropagation()">
                            <span class="material-symbols-outlined">more_vert</span>
                        </button>
                    </div>

                    <!-- Right side of header (for Deals only) -->
                    <div class="actions" *ngIf="isDeal()" style="margin-top: 0; padding-right: 8px;">
                        <button [attr.guide]="'lead-detail-panel-btn-15' + '__' + sanitizedUrl" mat-stroked-button
                            color="primary" (click)="gotoLeadDetailPage()">See all details</button>
                        <div class="nav-arrows" fxLayout="row" fxLayoutAlign="start center">
                            <button [attr.guide]="'lead-detail-panel-btn-16' + '__' + sanitizedUrl" mat-icon-button
                                (click)="goPrevious()" [disabled]="!allIds?.length || currentIndex <= 0">
                                <span class="material-symbols-outlined">chevron_left</span>
                            </button>

                            <button [attr.guide]="'lead-detail-panel-btn-17' + '__' + sanitizedUrl" mat-icon-button
                                (click)="goNext()" [disabled]="!allIds?.length || currentIndex >= allIds.length - 1">
                                <span class="material-symbols-outlined">chevron_right</span>
                            </button>

                            <!-- Close button placed at top right -->
                            <button mat-icon-button (click)="dialogRef.close()">
                                <mat-icon>close</mat-icon>
                            </button>
                        </div>
                    </div>
                    <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
                        <button [attr.guide]="'lead-detail-panel-btn-26' + '__' + sanitizedUrl"
                            [disabled]="!resourcePrivilege?.update" (click)="editProduct()" mat-menu-item>
                            <span class="material-symbols-outlined">edit</span>
                            <span>Edit</span>
                        </button>

                        <button [attr.guide]="'lead-detail-panel-btn-27' + '__' + sanitizedUrl"
                            [disabled]="!resourcePrivilege?.delete" (click)="deleteAllProductId()" mat-menu-item>
                            <span class="material-symbols-outlined">delete</span>
                            <span>Delete</span>
                        </button>

                    </mat-menu>

                </div>

                <div class="main-content-wrapper" [fxLayout]="isDeal() ? 'column' : 'row'" fxLayout.lt-md="column"
                    fxFlex>

                    <div class="left-sidebar" [style.width]="isDeal() ? '100%' : 'max-content'"
                        [fxLayout]="isDeal() ? 'row' : 'column'" fxLayoutGap="10px">



                        <nav class="left-navigation" [class.expanded]="isExpandedTwo"
                            (mouseenter)="isExpandedTwo = true" (mouseleave)="isExpandedTwo = false"
                            [ngStyle]="isDeal() ? {'width': '100%', 'height': 'auto', 'border-bottom': '1px solid #e2e8f0'} : {}">
                            <ul
                                [ngStyle]="isDeal() ? {'display': 'flex', 'flex-direction': 'row', 'overflow-x': 'auto', 'padding': '0', 'margin': '0'} : {}">
                                <li *ngFor="let tab of tabs" (click)="setActiveTab(tab.name)"
                                    [class.active]="activeTab === tab.name"
                                    [ngStyle]="isDeal() ? {'display': 'flex', 'flex-direction': 'row', 'align-items': 'center', 'padding': '12px 20px', 'white-space': 'nowrap', 'cursor': 'pointer'} : {}">
                                    <span class="material-symbols-outlined icon"
                                        [ngStyle]="isDeal() ? {'margin-right': '8px'} : {}">{{ tab.icon }}</span>
                                    <span class="tab-name" *ngIf="isDeal() ? true : isExpandedTwo">{{ tab.name }}</span>
                                </li>
                            </ul>
                        </nav>


                    </div>

                    <div class="right-content-area" fxLayout="row" fxLayout.lt-sm="column" fxFlex="100"
                        fxFlex.lt-md="100">
                        <div [ngSwitch]="activeTab" class="dynamic-content" style="width: 100%;">
                            <div *ngSwitchCase="'Overview'" class="overview">
                                <!-- 
  This container holds the entire overview screen.
  It's structured with a main content area on the left and a notes section on the right.
  This layout stacks vertically on smaller screens for responsiveness.
-->
                                <div class="overview-cont">
                                    <header class="overview-header">
                                        <h1 class="title">Overview</h1>
                                        <!-- <button [attr.guide]="'lead-detail-panel-btn-29' + '__' + sanitizedUrl" class="customize-btn">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="icon" fill="none"
                                            viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                        </svg>
                                        Customize overview
                                    </button> -->
                                    </header>

                                    <!-- Lifecycle and Status Pipeline Section -->
                                    <section class="pipeline-section">


                                        <div class="status-pipeline-wrapper">
                                            <label>Status</label>
                                            <div class="status-pipeline">
                                                <div *ngFor="let step of filtereddropdownTypeList; let i = index"
                                                    class="strip-stage" [ngClass]="{
         'stage-current': step.statusName === LeadDetailsObject.statusName,
         'stage-completed': i <= currentStatusIndex,
         'last-stage': i === filtereddropdownTypeList.length - 1
       }" [attr.data-toggle]="'tooltip'" [attr.data-html]="'true'" [attr.data-container]="'body'"
                                                    [attr.title]="generateTooltip(step)"
                                                    (click)="updateLeadStatusNew($event,step)">
                                                    <span>{{ step.statusName }}</span>
                                                </div>
                                            </div>



                                        </div>
                                    </section>
                                </div>


                                <div class="overview-container">

                                    <!-- Main Content Section (Left) -->
                                    <main class="main-content-two" fxFlex="55">

                                        <div class="info-item">
                                            <label>Lifecycle stage</label>
                                            <div class="value-display">
                                                <span>{{ lifeCycleStage }}</span>
                                                <!-- <button [attr.guide]="'lead-detail-panel-btn-30' + '__' + sanitizedUrl"
                                                    (click)="openEditPopup('lifeCycleStage', 
                                            'Lifecycle stage', 'select')" class="edit-btn">
                                                    <mat-icon>edit</mat-icon>
                                                </button> -->
                                            </div>

                                        </div>
                                        <!-- Key Stakeholder Tag -->
                                        <section class="tags-section">
                                            <div style="cursor: pointer;" class="tag key-stakeholder"
                                                (click)="openEditPopup('tagName', 'Tag Name', 'select')">
                                                <svg xmlns="http://www.w3.org/2000/svg" class="icon" fill="none"
                                                    viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
                                                </svg>
                                                {{LeadDetailsObject?.tagName || "No Tag"}}
                                            </div>
                                        </section>

                                        <!-- Contact Info Grid -->
                                        <section class="info-grid">
                                            <div *ngIf="mapLink?.length>0" class="info-item">
                                                <label>Location</label>
                                                <a [attr.guide]="'lead-detail-panel-lnk-31' + '__' + sanitizedUrl"
                                                    (click)="navigatelink(mapLink)">{{ mapLink }}</a>
                                            </div>
                                            <div class="info-item">
                                                <label>Company</label>
                                                <div class="value-display">
                                                    <a [attr.guide]="'lead-detail-panel-lnk-32' + '__' + sanitizedUrl"
                                                        (click)="goToCompany()">{{LeadDetailsObject?.company }}</a>
                                                    <button
                                                        [attr.guide]="'lead-detail-panel-btn-33' + '__' + sanitizedUrl"
                                                        (click)="openEditPopup('company', 'Company', 'text')"
                                                        class="edit-btn">
                                                        <mat-icon>edit</mat-icon>
                                                    </button>
                                                </div>

                                            </div>
                                            <div class="info-item">
                                                <label>Email</label>
                                                <div class="value-display">
                                                    <a [attr.guide]="'lead-detail-panel-lnk-34' + '__' + sanitizedUrl"
                                                        (click)="LeadDetailsObject?.email ? openEmailPopup() : null">{{LeadDetailsObject.email
                                                        }}</a>
                                                    <button
                                                        [attr.guide]="'lead-detail-panel-btn-35' + '__' + sanitizedUrl"
                                                        (click)="openEditPopup('email', 'Email', 'text')"
                                                        class="edit-btn">
                                                        <mat-icon>edit</mat-icon>
                                                    </button>
                                                </div>

                                            </div>
                                            <div class="info-item">
                                                <label>Mobile</label>
                                                <div class="value-display">
                                                    <a [attr.guide]="'lead-detail-panel-lnk-36' + '__' + sanitizedUrl"
                                                        (click)="LeadDetailsObject?.phoneNumber ? phoneNumbercall(LeadDetailsObject) : null">{{
                                                        LeadDetailsObject.phoneNumber
                                                        }}</a>
                                                    <button
                                                        [attr.guide]="'lead-detail-panel-btn-37' + '__' + sanitizedUrl"
                                                        (click)="openEditPopup('phoneNumber', 'Phone Number', 'number')"
                                                        class="edit-btn">
                                                        <mat-icon>edit</mat-icon>
                                                    </button>
                                                </div>

                                            </div>
                                            <div class="info-item">
                                                <label>Sales owner</label>
                                                <div class="value-display">
                                                    <span>{{ LeadDetailsObject?.ownerIdName?.split('@')[0] | titlecase
                                                        }}</span>
                                                    <button
                                                        [attr.guide]="'lead-detail-panel-btn-38' + '__' + sanitizedUrl"
                                                        (click)="transferLead()" class="edit-btn">
                                                        <mat-icon>edit</mat-icon>
                                                    </button>
                                                </div>

                                            </div>
                                            <!-- <div class="info-item">
                                            <label>Account</label>
                                            <a [attr.guide]="'lead-detail-panel-lnk-39' + '__' + sanitizedUrl" (click)="companyDetailPage(LeadDetailsObject?.companyId)">{{
                                                LeadDetailsObject?.company }}</a>
                                        </div>
                                        <div class="info-item">
                                            <label>Email</label>
                                            <a href="mailto:{{LeadDetailsObject.ownerEmail}}">{{
                                                LeadDetailsObject.email }}</a>
                                        </div>
                                        <div class="info-item">
                                            <label>Mobile</label>
                                            <a href="tel:{{LeadDetailsObject.phoneNumber}}">{{
                                                LeadDetailsObject.phoneNumber
                                                }}</a>
                                        </div>
                                        <div class="info-item">
                                            <label>Sales owner</label>
                                            <a>{{ LeadDetailsObject?.ownerIdName?.split('@')[0] | titlecase
                                                }}</a>
                                        </div> -->
                                            <div class="info-item">
                                                <label>Created at</label>
                                                <span>{{ LeadDetailsObject.createdDate | date:'MMM dd, yyyy, h:mm a'
                                                    }}</span>
                                            </div>
                                        </section>

                                        <a [attr.guide]="'lead-detail-panel-lnk-40' + '__' + sanitizedUrl"
                                            (click)="showToContactDetials()" class="show-all-link">
                                            Show all
                                            <svg xmlns="http://www.w3.org/2000/svg" class="dropdown-icon" fill="none"
                                                viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                    d="M19 9l-7 7-7-7" />
                                            </svg>
                                        </a>

                                        <!-- Action Cards Section -->
                                        <section class="action-cards-section">
                                            <div class="action-card">
                                                <div class="card-icon-wrapper">
                                                    <svg xmlns="http://www.w3.org/2000/svg" class="card-icon"
                                                        fill="none" viewBox="0 0 24 24" stroke="currentColor"
                                                        stroke-width="1.5">
                                                        <path stroke-linecap="round" stroke-linejoin="round"
                                                            d="M12 6v12m-3-2.818l.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.826-2.616-.826-3.723 0l-.17.127c-.89.67-2.178.67-3.067 0C2.36 11.41.966 11.41.1 12.284c-.866.866-.866 2.267 0 3.133l.17.127c.89.67 2.178.67 3.067 0l.659-.494m8.243-4.553c.428-.32.954-.32 1.382 0l.17.127c.89.67 2.178.67 3.067 0C21.64 13.37 23.034 13.37 23.9 14.24c.866.866.866 2.267 0 3.133l-.17.127c-.89.67-2.178.67-3.067 0l-.659-.494" />
                                                    </svg>
                                                </div>
                                                <div class="card-content">
                                                    <p *ngIf="noOfDeals > 0">
                                                        {{ noOfDeals }} deal(s) associated with
                                                        {{LeadDetailsObject?.name
                                                        }}.
                                                    </p>
                                                    <p *ngIf="noOfDeals === 0">
                                                        No open deals associated with {{LeadDetailsObject?.name }}.
                                                    </p>

                                                    <div class="card-links" *ngIf="noOfDeals === 0">
                                                        <a [attr.guide]="'lead-detail-panel-lnk-41' + '__' + sanitizedUrl"
                                                            (click)="goToDeals()" class="action-link">
                                                            Add deal
                                                        </a>
                                                    </div>

                                                </div>
                                            </div>

                                            <!-- Meetings -->
                                            <div class="action-card">
                                                <div class="card-icon-wrapper">
                                                    <svg xmlns="http://www.w3.org/2000/svg" class="card-icon"
                                                        fill="none" viewBox="0 0 24 24" stroke="currentColor"
                                                        stroke-width="1.5">
                                                        <path stroke-linecap="round" stroke-linejoin="round"
                                                            d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                                    </svg>
                                                </div>
                                                <div class="card-content">
                                                    <p *ngIf="noOfMeetings > 0">
                                                        {{ noOfMeetings }} upcoming meeting(s) with
                                                        {{LeadDetailsObject?.name}}.
                                                    </p>
                                                    <p *ngIf="noOfMeetings === 0">
                                                        No upcoming meetings with {{LeadDetailsObject?.name }}.
                                                    </p>

                                                    <div class="card-links" *ngIf="noOfMeetings === 0">
                                                        <a [attr.guide]="'lead-detail-panel-lnk-42' + '__' + sanitizedUrl"
                                                            (click)="addMeeting()" class="action-link">Add meeting</a>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- MailBox -->
                                            <div class="action-card">
                                                <div class="card-icon-wrapper">
                                                    <svg xmlns="http://www.w3.org/2000/svg" class="card-icon"
                                                        fill="none" viewBox="0 0 24 24" stroke="currentColor"
                                                        stroke-width="1.5">
                                                        <path stroke-linecap="round" stroke-linejoin="round"
                                                            d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                                    </svg>
                                                </div>
                                                <div class="card-content">
                                                    <p>
                                                        {{LeadDetailsObject?.name}} hasn't been contacted yet.
                                                    </p>
                                                    <div class="card-links">
                                                        <a [attr.guide]="'lead-detail-panel-lnk-43' + '__' + sanitizedUrl"
                                                            (click)="goToMailbox()" class="action-link">
                                                            Click here to send mail
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>

                                        </section>

                                    </main>


                                    <!-- Notes Section (Right) -->
                                    <div class="notes-container" fxFlex="40">
                                        <aside class="add-note-section notes-section">
                                            <div (click)="createNote(null, 0)">
                                                <span>Add a Note...</span>
                                            </div>
                                        </aside>


                                        <main class="notes-list" *ngIf="noteList.length > 0; else noNotes">
                                            <div *ngFor="let note of noteList" class="note-item">
                                                <div class="note-content"
                                                    [class.truncated]="note.notes.length > 250 && !isExpanded(note.noteId)"
                                                    [innerHTML]="note.notes">
                                                </div>

                                                <a *ngIf="note.notes.length > 250" (click)="toggleShowMore(note.noteId)"
                                                    class="show-more-link">
                                                    {{ isExpanded(note.noteId) ? 'Show less' : 'Show more' }}
                                                </a>


                                                <div class="padding-10" *ngIf="note.documentType == 1">
                                                    <video [style.height]="'150px'" [style.width]="'75%'" controls>
                                                        <source [src]="serverPathNotes + note.notesDocument + cid" />
                                                    </video>
                                                </div>
                                                <div class="padding-10" *ngIf="note.documentType == 2">
                                                    <audio controls>
                                                        <source [src]="serverPathNotes + note.notesDocument + cid" />
                                                    </audio>
                                                </div>


                                                <div class="padding-10" *ngIf="note.documentType==3">
                                                    <div fxLayout="column">

                                                        <div fxLayout="row">
                                                            <span fxLayoutAlign="start center">
                                                                Pdf : {{note.notesDocument}}
                                                            </span>

                                                            <button
                                                                [attr.guide]="'lead-detail-panel-btn-44' + '__' + sanitizedUrl"
                                                                (click)="downloadNew(serverPathNotes + note.notesDocument + cid, note.documentType)"
                                                                color="warn" mat-icon-button type="button">
                                                                <mat-icon>download

                                                                </mat-icon>

                                                            </button>
                                                        </div>

                                                    </div>
                                                </div>

                                                <div class="padding-10" *ngIf="note.documentType==4">
                                                    <div fxLayout="column">
                                                        <div fxLayout="row">

                                                            <calsoft-common-images
                                                                [src]="serverPathNotes + note.notesDocument"
                                                                [height]="'50%'" [width]="'25%'" [alt]="">

                                                            </calsoft-common-images>

                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="padding-10" *ngIf="note.documentType==5">
                                                    <div fxLayout="column">
                                                        <div fxLayout="row">

                                                            <img *ngIf="note.notesDocument?.endsWith('.doc') || note.notesDocument?.endsWith('.docx')"
                                                                src="assets/images/docx.png" width="36" height="36"
                                                                alt="DOCX File">

                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="padding-10" *ngIf="note.documentType==6">
                                                    <div fxLayout="column">
                                                        <div fxLayout="row">

                                                            <img *ngIf="note.notesDocument?.endsWith('.xls') || note.notesDocument?.endsWith('.xlsx')"
                                                                src="assets/images/excel.png" width="36" height="36"
                                                                alt="Excel File">

                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="note-meta">
                                                    <mat-icon class="edit-icon" (click)="createNote(note, note.noteId)"
                                                        style="height: auto;">edit_square</mat-icon>
                                                    <span>
                                                        {{ note.createdBy == null ? LeadDetailsObject?.ownerEmail :
                                                        note.createdBy }}
                                                    </span>
                                                    <span class="dot">•</span>
                                                    <span>{{ note.createdDate | date:'mediumDate' }}</span>
                                                </div>
                                            </div>
                                        </main>

                                        <ng-template #noNotes>
                                            <div class="empty-state-two">
                                                <mat-icon>note_add</mat-icon>
                                                <p>No notes yet.</p>
                                                <span>Add a note to get started.</span>
                                            </div>
                                        </ng-template>

                                    </div>

                                </div>



                            </div>

                            <div *ngSwitchCase="'Contact details'">
                                <div class="contact-details-container">
                                    <div class="details-header">
                                        <h2>Contact details</h2>
                                        <!-- <div class="header-actions">
                                        <button [attr.guide]="'lead-detail-panel-btn-45' + '__' + sanitizedUrl" class="btn-secondary">View field edit history</button>
                                        <button [attr.guide]="'lead-detail-panel-btn-46' + '__' + sanitizedUrl" class="btn-secondary">Manage fields</button>
                                    </div> -->
                                    </div>

                                    <div class="details-tabs">
                                        <button [attr.guide]="'lead-detail-panel-btn-47' + '__' + sanitizedUrl"
                                            [class.active]="activeView === 'all'" (click)="setView('all')">All
                                            details</button>
                                        <button [attr.guide]="'lead-detail-panel-btn-48' + '__' + sanitizedUrl"
                                            [class.active]="activeView === 'basic'" (click)="setView('basic')">Basic
                                            information</button>
                                    </div>

                                    <!--         <div class="details-toolbar">
                                    <div class="search-bar">
                                        <i class="icon-search"></i>
                                        <input [attr.guide]="'lead-detail-panel-inp-49' + '__' + sanitizedUrl" type="text" placeholder="Search fields" />
                                    </div>
                                     <div class="toggle-switch">
                                    <span>Show empty fields</span>
                                    <label class="switch">
                                        <input [attr.guide]="'lead-detail-panel-inp-50' + '__' + sanitizedUrl" type="checkbox" checked />
                                        <span class="slider round"></span>
                                    </label>
                                </div> 
                                </div>
                                -->

                                    <div class="details-content">
                                        <div *ngIf="activeView === 'all'">
                                            <!-- <div class="all-details-tags">
                                        <span class="label">Tags</span>
                                        <span class="tag">{{ contact.tags[0] }}</span>
                                    </div> -->

                                            <div class="content-section">
                                                <button [attr.guide]="'lead-detail-panel-btn-51' + '__' + sanitizedUrl"
                                                    class="section-toggle" (click)="toggleBasicInfo()">
                                                    <i class="icon-chevron" [class.rotated]="isBasicInfoOpen"></i>
                                                    <h3>Basic information</h3>
                                                </button>
                                                <div class="section-body" *ngIf="isBasicInfoOpen">
                                                    <div class="details-grid-4col" *ngIf="!isDeal()">
                                                        <!-- <div class="field-item"><span class="label">Email</span><a class="value link">{{ LeadDetailsObject?.email }}</a></div> -->
                                                        <div class="info-item">
                                                            <label>Email</label>
                                                            <div class="value-display">
                                                                <a [attr.guide]="'lead-detail-panel-lnk-52' + '__' + sanitizedUrl"
                                                                    (click)="LeadDetailsObject?.email ? openEmailPopup() : null">{{LeadDetailsObject?.email
                                                                    }}</a>
                                                                <button
                                                                    [attr.guide]="'lead-detail-panel-btn-53' + '__' + sanitizedUrl"
                                                                    (click)="openEditPopup('email', 'Email', 'text')"
                                                                    class="edit-btn">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>
                                                            </div>

                                                        </div>
                                                        <!-- <div class="field-item"><span class="label">Name</span><span
                                                        class="value">{{LeadDetailsObject?.name }}</span></div> -->
                                                        <div class="info-item">
                                                            <label>Name</label>
                                                            <div class="value-display">
                                                                <a>{{LeadDetailsObject?.name }}</a>
                                                                <button
                                                                    [attr.guide]="'lead-detail-panel-btn-54' + '__' + sanitizedUrl"
                                                                    (click)="openEditPopup('name', 'Name', 'text')"
                                                                    class="edit-btn">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>
                                                            </div>

                                                        </div>
                                                        <!-- <div class="field-item"><span class="label">Last name</span><span
                                                        class="value">{{ contact.lastName }}</span></div> -->
                                                        <!-- <div class="field-item"><span class="label">Account</span><a class="value link">{{ LeadDetailsObject?.company }}</a></div> -->
                                                        <div class="info-item">
                                                            <label>Company</label>
                                                            <div class="value-display">
                                                                <a [attr.guide]="'lead-detail-panel-lnk-55' + '__' + sanitizedUrl"
                                                                    (click)="goToCompany()">{{LeadDetailsObject?.company
                                                                    }}</a>
                                                                <button
                                                                    [attr.guide]="'lead-detail-panel-btn-56' + '__' + sanitizedUrl"
                                                                    (click)="openEditPopup('company', 'Company', 'text')"
                                                                    class="edit-btn">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>
                                                            </div>

                                                        </div>
                                                        <!-- <div class="field-item"><span class="label">Job title</span><span
                                                        class="value">{{ LeadDetailsObject?.jobtitle }}</span></div> -->
                                                        <div class="info-item">
                                                            <label>Job title</label>
                                                            <div class="value-display">
                                                                <a>{{LeadDetailsObject?.jobtitle }}</a>
                                                                <button
                                                                    [attr.guide]="'lead-detail-panel-btn-57' + '__' + sanitizedUrl"
                                                                    (click)="openEditPopup('jobtitle', 'Jobtitle', 'text')"
                                                                    class="edit-btn">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div class="details-grid-4col" *ngIf="isDeal()">
                                                        <div class="info-item">
                                                            <label>Deals Name</label>
                                                            <div class="value-display">
                                                                <a>{{LeadDetailsObject?.dealsName || '--' }}</a>
                                                            </div>
                                                        </div>
                                                        <div class="info-item">
                                                            <label>Product</label>
                                                            <div class="value-display">
                                                                <a>{{LeadDetailsObject?.product || '--' }}</a>
                                                            </div>
                                                        </div>
                                                        <div class="info-item">
                                                            <label>Deal Value</label>
                                                            <div class="value-display">
                                                                <a>{{LeadDetailsObject?.amount || '--' }}</a>
                                                            </div>
                                                        </div>
                                                        <div class="info-item">
                                                            <label>Deal Stage</label>
                                                            <div class="value-display">
                                                                <a>{{LeadDetailsObject?.stage || '--' }}</a>
                                                            </div>
                                                        </div>
                                                        <div class="info-item">
                                                            <label>Sales Owner</label>
                                                            <div class="value-display">
                                                                <a>{{LeadDetailsObject?.dealsOwner || '--' }}</a>
                                                            </div>
                                                        </div>
                                                        <div class="info-item">
                                                            <label>Closing Date</label>
                                                            <div class="value-display">
                                                                <a>{{ (LeadDetailsObject?.closingDate |
                                                                    date:'mediumDate') || '--' }}</a>
                                                            </div>
                                                        </div>
                                                        <div class="info-item">
                                                            <label>Expected Closing Date</label>
                                                            <div class="value-display">
                                                                <a>{{ (LeadDetailsObject?.expectedClosingDate |
                                                                    date:'mediumDate') || '--' }}</a>
                                                            </div>
                                                        </div>
                                                        <div class="info-item">
                                                            <label>Lead Created Date</label>
                                                            <div class="value-display">
                                                                <a>{{ (LeadDetailsObject?.leadCreatedDate |
                                                                    date:'mediumDate') || '--' }}</a>
                                                            </div>
                                                        </div>
                                                        <div class="info-item">
                                                            <label>Lead Name</label>
                                                            <div class="value-display">
                                                                <a>{{LeadDetailsObject?.leadName || '--' }}</a>
                                                            </div>
                                                        </div>
                                                        <div class="info-item">
                                                            <label>Company Name</label>
                                                            <div class="value-display">
                                                                <a>{{LeadDetailsObject?.company || '--' }}</a>
                                                            </div>
                                                        </div>
                                                        <div class="info-item">
                                                            <label>Created Date</label>
                                                            <div class="value-display">
                                                                <a>{{ (LeadDetailsObject?.createdDate |
                                                                    date:'mediumDate') || '--' }}</a>
                                                            </div>
                                                        </div>
                                                        <div class="info-item">
                                                            <label>Updated Date</label>
                                                            <div class="value-display">
                                                                <a>{{ (LeadDetailsObject?.updatedDate |
                                                                    date:'mediumDate') || '--' }}</a>
                                                            </div>
                                                        </div>
                                                        <div class="info-item">
                                                            <label>Reason For Loss</label>
                                                            <div class="value-display">
                                                                <a>{{LeadDetailsObject?.reasonForLoss || '--' }}</a>
                                                            </div>
                                                        </div>
                                                        <div class="info-item">
                                                            <label>Renewal Date</label>
                                                            <div class="value-display">
                                                                <a>{{ (LeadDetailsObject?.renewalDate |
                                                                    date:'mediumDate') || '--' }}</a>
                                                            </div>
                                                        </div>
                                                        <div class="info-item">
                                                            <label>Probability</label>
                                                            <div class="value-display">
                                                                <a>{{LeadDetailsObject?.probability || '--' }}</a>
                                                            </div>
                                                        </div>
                                                        <div class="info-item">
                                                            <label>Paid</label>
                                                            <div class="value-display">
                                                                <a>{{LeadDetailsObject?.paid || '--' }}</a>
                                                            </div>
                                                        </div>
                                                        <div class="info-item">
                                                            <label>Balance</label>
                                                            <div class="value-display">
                                                                <a>{{LeadDetailsObject?.balance || '--' }}</a>
                                                            </div>
                                                        </div>
                                                        <div class="info-item">
                                                            <label>Payment Status</label>
                                                            <div class="value-display">
                                                                <a>{{LeadDetailsObject?.paymentStatus || '--' }}</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="content-section">
                                                <div class="section-header">
                                                    <h4>Telephone numbers</h4>
                                                </div>
                                                <div class="section-body">
                                                    <div class="details-grid-4col">
                                                        <!-- <div class="field-item"><span class="label">Mobile</span><span
                                                        class="value">{{ LeadDetailsObject?.phoneNumber }}</span></div> -->
                                                        <div class="info-item">
                                                            <label>Mobile</label>
                                                            <div class="value-display">
                                                                <a [attr.guide]="'lead-detail-panel-lnk-58' + '__' + sanitizedUrl"
                                                                    (click)="LeadDetailsObject?.phoneNumber ? phoneNumbercall(LeadDetailsObject) : null">{{
                                                                    LeadDetailsObject.phoneNumber
                                                                    }}</a>
                                                                <button
                                                                    [attr.guide]="'lead-detail-panel-btn-59' + '__' + sanitizedUrl"
                                                                    (click)="openEditPopup('phoneNumber', 'Phone Number', 'number')"
                                                                    class="edit-btn">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>
                                                            </div>

                                                        </div>
                                                        <!-- <div class="field-item"><span class="label">Work phone</span><span
                                                        class="value">{{ LeadDetailsObject?.secondaryphoneno
                                                        }}</span></div> -->
                                                        <div class="info-item">
                                                            <label>Work phone</label>
                                                            <div class="value-display">
                                                                <a [attr.guide]="'lead-detail-panel-lnk-60' + '__' + sanitizedUrl"
                                                                    (click)="LeadDetailsObject?.secondaryphoneno ? phoneNumbercallSecondary(LeadDetailsObject) : null">{{
                                                                    LeadDetailsObject.secondaryphoneno
                                                                    }}</a>
                                                                <button
                                                                    [attr.guide]="'lead-detail-panel-btn-61' + '__' + sanitizedUrl"
                                                                    (click)="openEditPopup('secondaryphoneno', 'Secondary Phone No', 'number')"
                                                                    class="edit-btn">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="content-section">
                                                <div class="section-header">
                                                    <h4>Sales owner</h4>
                                                </div>
                                                <!-- <div class="section-body">
                                                <div class="details-grid-4col">
                                                    <div class="field-item"><span class="label">Sales owner</span><span
                                                            class="value">{{
                                                            LeadDetailsObject?.ownerIdName?.split('@')[0] |
                                                            titlecase }}</span></div>
                                                </div>
                                            </div> -->
                                                <div class="info-item">
                                                    <label>Sales owner</label>
                                                    <div class="value-display">
                                                        <a>{{ LeadDetailsObject?.ownerIdName?.split('@')[0] | titlecase
                                                            }}</a>
                                                        <button
                                                            [attr.guide]="'lead-detail-panel-btn-62' + '__' + sanitizedUrl"
                                                            (click)="transferLead()" class="edit-btn">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                    </div>

                                                </div>
                                            </div>

                                            <div class="content-section">
                                                <button [attr.guide]="'lead-detail-panel-btn-63' + '__' + sanitizedUrl"
                                                    class="section-toggle" (click)="toggleMoreFields()">
                                                    <i class="icon-chevron" [class.rotated]="isMoreFieldsOpen"></i>
                                                    <h3>More fields</h3>
                                                </button>
                                                <div class="section-body" *ngIf="isMoreFieldsOpen">

                                                    <div class="sub-section">
                                                        <div class="section-header">
                                                            <h4>Location</h4>
                                                        </div>
                                                        <div class="section-body">
                                                            <div class="details-grid-4col">
                                                                <!-- <div class="field-item" style="grid-column: span 4;"><span
                                                                class="label">Address</span><span class="value">{{
                                                                LeadDetailsObject?.additionalSpec?.Address }}</span>
                                                        </div> -->
                                                                <div class="info-item">
                                                                    <label>Address</label>
                                                                    <div class="value-display">
                                                                        <a>{{
                                                                            LeadDetailsObject.additionalSpec?.Address}}</a>
                                                                        <button
                                                                            [attr.guide]="'lead-detail-panel-btn-64' + '__' + sanitizedUrl"
                                                                            (click)="openEditPopup('Address', 'Address', 'text')"
                                                                            class="edit-btn">
                                                                            <mat-icon>edit</mat-icon>
                                                                        </button>
                                                                    </div>

                                                                </div>
                                                                <!-- <div class="field-item"><span class="label">City</span><span
                                                                class="value">{{
                                                                LeadDetailsObject?.isCustomizedValue?.City }}</span>
                                                        </div> -->
                                                                <div class="info-item">
                                                                    <label>City</label>
                                                                    <div class="value-display">
                                                                        <a>{{
                                                                            LeadDetailsObject.isCustomizedValue?.City}}</a>
                                                                        <button
                                                                            [attr.guide]="'lead-detail-panel-btn-65' + '__' + sanitizedUrl"
                                                                            (click)="openEditPopup('City', 'City', 'text')"
                                                                            class="edit-btn">
                                                                            <mat-icon>edit</mat-icon>
                                                                        </button>
                                                                    </div>

                                                                </div>
                                                                <!-- <div class="field-item"><span class="label">State</span><span
                                                                class="value">{{
                                                                LeadDetailsObject?.isCustomizedValue?.State }}</span>
                                                        </div> -->
                                                                <div class="info-item">
                                                                    <label>State</label>
                                                                    <div class="value-display">
                                                                        <a>{{
                                                                            LeadDetailsObject.isCustomizedValue?.State}}</a>
                                                                        <button
                                                                            [attr.guide]="'lead-detail-panel-btn-66' + '__' + sanitizedUrl"
                                                                            (click)="openEditPopup('State', 'State', 'text')"
                                                                            class="edit-btn">
                                                                            <mat-icon>edit</mat-icon>
                                                                        </button>
                                                                    </div>

                                                                </div>
                                                                <!-- <div class="field-item"><span class="label">Country</span><span
                                                                class="value">{{ LeadDetailsObject?.country }}</span>
                                                        </div> -->
                                                                <div class="info-item">
                                                                    <label>Country</label>
                                                                    <div class="value-display">
                                                                        <a>{{
                                                                            LeadDetailsObject.country}}</a>
                                                                        <button
                                                                            [attr.guide]="'lead-detail-panel-btn-67' + '__' + sanitizedUrl"
                                                                            (click)="openEditPopup('Country', 'country', 'select')"
                                                                            class="edit-btn">
                                                                            <mat-icon>edit</mat-icon>
                                                                        </button>
                                                                    </div>

                                                                </div>
                                                                <!-- <div class="field-item"><span class="label">Zipcode</span><span
                                                                class="value">{{
                                                                LeadDetailsObject?.isCustomizedValue?.pincode }}</span>
                                                        </div> -->
                                                                <div class="info-item">
                                                                    <label>Zipcode</label>
                                                                    <div class="value-display">
                                                                        <a>{{
                                                                            LeadDetailsObject.isCustomizedValue?.Pincode}}</a>
                                                                        <button
                                                                            [attr.guide]="'lead-detail-panel-btn-68' + '__' + sanitizedUrl"
                                                                            (click)="openEditPopup('pincode', 'Pincode', 'text')"
                                                                            class="edit-btn">
                                                                            <mat-icon>edit</mat-icon>
                                                                        </button>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="sub-section">
                                                        <div class="section-header">
                                                            <h4>Lifecycle stage</h4>
                                                        </div>
                                                        <div class="section-body">
                                                            <div class="details-grid-4col">
                                                                <!-- <div class="field-item"><span class="label">Lifecycle
                                                                stage</span><span class="value strong">{{
                                                                contact.lifecycleStage }}</span></div> -->
                                                                <!-- <div class="field-item"><span
                                                                    class="label">Status</span><span
                                                                    class="value strong">{{ LeadDetailsObject.statusName
                                                                    }}</span></div> -->
                                                                <div class="info-item">
                                                                    <label>Status</label>
                                                                    <div class="value-display">
                                                                        <a>{{LeadDetailsObject.statusName}}</a>
                                                                        <button
                                                                            [attr.guide]="'lead-detail-panel-btn-69' + '__' + sanitizedUrl"
                                                                            (click)="openEditPopup('statusName', 'Status Name', 'select')"
                                                                            class="edit-btn">
                                                                            <mat-icon>edit</mat-icon>
                                                                        </button>
                                                                    </div>

                                                                </div>

                                                                <!-- <div class="field-item"><span class="label">Lost
                                                                    reason</span><span style="color: rgb(93, 93, 207);"
                                                                    class="value placeholder"
                                                                    (click)="createNote(null, 0)">Click to
                                                                    add</span></div> -->

                                                                <div class="info-item">
                                                                    <label>Lost reason</label>
                                                                    <div class="value-display">
                                                                        <a
                                                                            *ngIf="LeadDetailsObject?.lostReason; else addReason">{{
                                                                            LeadDetailsObject.lostReason
                                                                            }}</a>
                                                                        <button
                                                                            [attr.guide]="'lead-detail-panel-btn-70' + '__' + sanitizedUrl"
                                                                            (click)="openEditPopup('lostReason', 'Lost Reason', 'text')"
                                                                            class="edit-btn">
                                                                            <mat-icon>edit</mat-icon>
                                                                        </button>

                                                                        <ng-template #addReason>
                                                                            <span style="color: rgb(93, 93, 207);"
                                                                                class="value placeholder"
                                                                                (click)="createNote(null, 0)">
                                                                                Click to add
                                                                            </span>
                                                                        </ng-template>
                                                                    </div>

                                                                </div>
                                                                <!-- <div class="field-item"><span class="label">Subscription
                                                                status</span><span class="value strong">{{
                                                                contact.subscriptionStatus }}</span></div> -->
                                                                <!-- <div class="field-item" style="grid-column: span 2;"><span
                                                                class="label">Subscription types</span><span
                                                                class="value">{{ contact.subscriptionTypes }}</span>
                                                        </div> -->
                                                                <!-- <div class="field-item"><span class="label">Unsubscribe
                                                                reason</span><span class="value placeholder">Click to
                                                                add</span></div>
                                                        <div class="field-item"><span class="label">Other unsubscribe
                                                                reasons</span><span class="value placeholder">Click to
                                                                add</span></div> -->
                                                                <!-- <div class="field-item"><span class="label">Customer
                                                                    fit</span>
                                                                <div class="stars">
                                                                    <ng-container
                                                                        *ngFor="let star of starsArray; let i = index">
                                                                        <span class="material-symbols-outlined"
                                                                            [ngClass]="{ 'fill': i < filledStars }">
                                                                            star
                                                                        </span>
                                                                    </ng-container>
                                                                </div>
                                                            </div> -->
                                                                <!-- <div class="field-item"><span
                                                                    class="label">Score</span><span
                                                                    class="value strong">{{ LeadDetailsObject.score
                                                                    }}</span>
                                                            </div> -->
                                                                <div class="info-item">
                                                                    <label>Score</label>
                                                                    <div class="value-display">
                                                                        <a>{{ LeadDetailsObject.score}}</a>

                                                                    </div>

                                                                </div>
                                                                <!-- <div class="field-item"><span
                                                                class="label">Territory</span><span
                                                                class="value placeholder">Click to add</span></div> -->
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="sub-section">
                                                        <div class="section-header">
                                                            <h4>Social profiles</h4>
                                                        </div>
                                                        <div class="section-body">
                                                            <div class="details-grid-4col">
                                                                <!-- <div class="field-item"><span
                                                                    class="label">LinkedIn</span><a class="value link">{{ LeadDetailsObject.linkedIn
                                                                    }}</a>
                                                            </div>
                                                            <div class="field-item"><span class="label">Twitter</span><a class="value link">{{ LeadDetailsObject.twitter
                                                                    }}</a>
                                                            </div>
                                                            <div class="field-item"><span
                                                                    class="label">Facebook</span><a class="value link">{{ LeadDetailsObject.facebook
                                                                    }}</a>
                                                            </div> -->
                                                                <div class="info-item">
                                                                    <label>LinkedIn</label>
                                                                    <div class="value-display">
                                                                        <a>{{ LeadDetailsObject.linkedIn}}</a>
                                                                        <button
                                                                            [attr.guide]="'lead-detail-panel-btn-71' + '__' + sanitizedUrl"
                                                                            (click)="openEditPopup('linkedIn', 'LinkedIn', 'text')"
                                                                            class="edit-btn">
                                                                            <mat-icon>edit</mat-icon>
                                                                        </button>
                                                                    </div>

                                                                </div>
                                                                <div class="info-item">
                                                                    <label>Twitter</label>
                                                                    <div class="value-display">
                                                                        <a>{{ LeadDetailsObject.twitter}}</a>
                                                                        <button
                                                                            [attr.guide]="'lead-detail-panel-btn-72' + '__' + sanitizedUrl"
                                                                            (click)="openEditPopup('twitter', 'Twitter', 'text')"
                                                                            class="edit-btn">
                                                                            <mat-icon>edit</mat-icon>
                                                                        </button>
                                                                    </div>

                                                                </div>
                                                                <div class="info-item">
                                                                    <label>Facebook</label>
                                                                    <div class="value-display">
                                                                        <a>{{ LeadDetailsObject.facebook}}</a>
                                                                        <button
                                                                            [attr.guide]="'lead-detail-panel-btn-73' + '__' + sanitizedUrl"
                                                                            (click)="openEditPopup('facebook', 'Facebook', 'text')"
                                                                            class="edit-btn">
                                                                            <mat-icon>edit</mat-icon>
                                                                        </button>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>

                                        <div *ngIf="activeView === 'basic'">

                                            <div class="content-section">
                                                <div class="section-header">
                                                    <h3>Basic information</h3>
                                                </div>
                                                <div class="section-body">
                                                    <div class="details-grid-4col" *ngIf="!isDeal()">
                                                        <!-- <div class="field-item"><span class="label">Email</span><a class="value link">{{ LeadDetailsObject?.email }}</a></div>
                                                    <div class="field-item"><span class="label">Name</span><span
                                                            class="value">{{LeadDetailsObject?.name }}</span></div>
                                                    <div class="field-item"><span class="label">Account</span><a class="value link">{{ LeadDetailsObject?.company }}</a>
                                                    </div>
                                                    <div class="field-item"><span class="label">Job title</span><span
                                                            class="value">{{ LeadDetailsObject?.jobtitle }}</span></div> -->
                                                        <div class="info-item">
                                                            <label>Email</label>
                                                            <div class="value-display">
                                                                <a [attr.guide]="'lead-detail-panel-lnk-74' + '__' + sanitizedUrl"
                                                                    (click)="LeadDetailsObject?.email ? openEmailPopup() : null">{{LeadDetailsObject?.email
                                                                    }}</a>
                                                                <button
                                                                    [attr.guide]="'lead-detail-panel-btn-75' + '__' + sanitizedUrl"
                                                                    (click)="openEditPopup('email', 'Email', 'text')"
                                                                    class="edit-btn">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>
                                                            </div>

                                                        </div>
                                                        <div class="info-item">
                                                            <label>Name</label>
                                                            <div class="value-display">
                                                                <a>{{LeadDetailsObject?.name }}</a>
                                                                <button
                                                                    [attr.guide]="'lead-detail-panel-btn-76' + '__' + sanitizedUrl"
                                                                    (click)="openEditPopup('name', 'Name', 'text')"
                                                                    class="edit-btn">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>
                                                            </div>

                                                        </div>
                                                        <div class="info-item">
                                                            <label>Company</label>
                                                            <div class="value-display">
                                                                <a>{{LeadDetailsObject?.company }}</a>
                                                                <button
                                                                    [attr.guide]="'lead-detail-panel-btn-77' + '__' + sanitizedUrl"
                                                                    (click)="openEditPopup('company', 'Company', 'text')"
                                                                    class="edit-btn">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>
                                                            </div>

                                                        </div>
                                                        <div class="info-item">
                                                            <label>Job title</label>
                                                            <div class="value-display">
                                                                <a>{{LeadDetailsObject?.jobtitle }}</a>
                                                                <button
                                                                    [attr.guide]="'lead-detail-panel-btn-78' + '__' + sanitizedUrl"
                                                                    (click)="openEditPopup('jobtitle', 'Jobtitle', 'text')"
                                                                    class="edit-btn">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div class="details-grid-4col" *ngIf="isDeal()">
                                                        <div class="info-item">
                                                            <label>Deals Name</label>
                                                            <div class="value-display">
                                                                <a>{{LeadDetailsObject?.dealsName || '--' }}</a>
                                                            </div>
                                                        </div>
                                                        <div class="info-item">
                                                            <label>Product</label>
                                                            <div class="value-display">
                                                                <a>{{LeadDetailsObject?.product || '--' }}</a>
                                                            </div>
                                                        </div>
                                                        <div class="info-item">
                                                            <label>Deal Value</label>
                                                            <div class="value-display">
                                                                <a>{{LeadDetailsObject?.amount || '--' }}</a>
                                                            </div>
                                                        </div>
                                                        <div class="info-item">
                                                            <label>Deal Stage</label>
                                                            <div class="value-display">
                                                                <a>{{LeadDetailsObject?.stage || '--' }}</a>
                                                            </div>
                                                        </div>
                                                        <div class="info-item">
                                                            <label>Sales Owner</label>
                                                            <div class="value-display">
                                                                <a>{{LeadDetailsObject?.dealsOwner || '--' }}</a>
                                                            </div>
                                                        </div>
                                                        <div class="info-item">
                                                            <label>Closing Date</label>
                                                            <div class="value-display">
                                                                <a>{{ (LeadDetailsObject?.closingDate |
                                                                    date:'mediumDate') || '--' }}</a>
                                                            </div>
                                                        </div>
                                                        <div class="info-item">
                                                            <label>Expected Closing Date</label>
                                                            <div class="value-display">
                                                                <a>{{ (LeadDetailsObject?.expectedClosingDate |
                                                                    date:'mediumDate') || '--' }}</a>
                                                            </div>
                                                        </div>
                                                        <div class="info-item">
                                                            <label>Lead Created Date</label>
                                                            <div class="value-display">
                                                                <a>{{ (LeadDetailsObject?.leadCreatedDate |
                                                                    date:'mediumDate') || '--' }}</a>
                                                            </div>
                                                        </div>
                                                        <div class="info-item">
                                                            <label>Lead Name</label>
                                                            <div class="value-display">
                                                                <a>{{LeadDetailsObject?.leadName || '--' }}</a>
                                                            </div>
                                                        </div>
                                                        <div class="info-item">
                                                            <label>Company Name</label>
                                                            <div class="value-display">
                                                                <a>{{LeadDetailsObject?.company || '--' }}</a>
                                                            </div>
                                                        </div>
                                                        <div class="info-item">
                                                            <label>Created Date</label>
                                                            <div class="value-display">
                                                                <a>{{ (LeadDetailsObject?.createdDate |
                                                                    date:'mediumDate') || '--' }}</a>
                                                            </div>
                                                        </div>
                                                        <div class="info-item">
                                                            <label>Updated Date</label>
                                                            <div class="value-display">
                                                                <a>{{ (LeadDetailsObject?.updatedDate |
                                                                    date:'mediumDate') || '--' }}</a>
                                                            </div>
                                                        </div>
                                                        <div class="info-item">
                                                            <label>Reason For Loss</label>
                                                            <div class="value-display">
                                                                <a>{{LeadDetailsObject?.reasonForLoss || '--' }}</a>
                                                            </div>
                                                        </div>
                                                        <div class="info-item">
                                                            <label>Renewal Date</label>
                                                            <div class="value-display">
                                                                <a>{{ (LeadDetailsObject?.renewalDate |
                                                                    date:'mediumDate') || '--' }}</a>
                                                            </div>
                                                        </div>
                                                        <div class="info-item">
                                                            <label>Probability</label>
                                                            <div class="value-display">
                                                                <a>{{LeadDetailsObject?.probability || '--' }}</a>
                                                            </div>
                                                        </div>
                                                        <div class="info-item">
                                                            <label>Paid</label>
                                                            <div class="value-display">
                                                                <a>{{LeadDetailsObject?.paid || '--' }}</a>
                                                            </div>
                                                        </div>
                                                        <div class="info-item">
                                                            <label>Balance</label>
                                                            <div class="value-display">
                                                                <a>{{LeadDetailsObject?.balance || '--' }}</a>
                                                            </div>
                                                        </div>
                                                        <div class="info-item">
                                                            <label>Payment Status</label>
                                                            <div class="value-display">
                                                                <a>{{LeadDetailsObject?.paymentStatus || '--' }}</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="content-section">
                                                <div class="section-header">
                                                    <h4>Telephone numbers</h4>
                                                </div>
                                                <div class="section-body">
                                                    <div class="details-grid-4col">
                                                        <!-- <div class="field-item"><span class="label">Mobile</span><span
                                                            class="value">{{ LeadDetailsObject?.phoneNumber }}</span>
                                                    </div>
                                                    <div class="field-item"><span class="label">Work phone</span><span
                                                            class="value">{{
                                                            LeadDetailsObject?.secondaryphoneno}}</span></div> -->
                                                        <div class="info-item">
                                                            <label>Mobile</label>
                                                            <div class="value-display">
                                                                <a href="tel:{{LeadDetailsObject.phoneNumber}}">{{
                                                                    LeadDetailsObject.phoneNumber
                                                                    }}</a>
                                                                <button
                                                                    [attr.guide]="'lead-detail-panel-btn-79' + '__' + sanitizedUrl"
                                                                    (click)="openEditPopup('phoneNumber', 'Phone Number', 'number')"
                                                                    class="edit-btn">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>
                                                            </div>

                                                        </div>
                                                        <div class="info-item">
                                                            <label>Work phone</label>
                                                            <div class="value-display">
                                                                <a href="tel:{{LeadDetailsObject?.secondaryphoneno}}">{{
                                                                    LeadDetailsObject.secondaryphoneno
                                                                    }}</a>
                                                                <button
                                                                    [attr.guide]="'lead-detail-panel-btn-80' + '__' + sanitizedUrl"
                                                                    (click)="openEditPopup('secondaryphoneno', 'Secondary Phone No', 'number')"
                                                                    class="edit-btn">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="content-section">
                                                <div class="section-header">
                                                    <h4>Sales owner</h4>
                                                </div>
                                                <div class="section-body">
                                                    <!-- <div class="details-grid-4col">
                                                    <div class="field-item"><span class="label">Sales owner</span><span
                                                            class="value">{{
                                                            LeadDetailsObject?.ownerIdName?.split('@')[0] | titlecase
                                                            }}</span></div>
                                                </div> -->
                                                    <div class="info-item">
                                                        <label>Sales owner</label>
                                                        <div class="value-display">
                                                            <a>{{ LeadDetailsObject?.ownerIdName?.split('@')[0] |
                                                                titlecase
                                                                }}</a>
                                                            <button
                                                                [attr.guide]="'lead-detail-panel-btn-81' + '__' + sanitizedUrl"
                                                                (click)="transferLead()" class="edit-btn">
                                                                <mat-icon>edit</mat-icon>
                                                            </button>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <div *ngSwitchCase="'Conversations'">
                            <div class="card">
                                <div *ngIf="leadLoaded">
                                    <calsoft-whatsapp-chat-details [contactId]="LeadDetailsObject?.phoneNumber"
                                        [isFromPhone]="true"></calsoft-whatsapp-chat-details>
                                </div>
                            </div>

                        </div> -->
                            <div *ngSwitchCase="'My Views'">
                                <div class="contact-details-container">
                                    <div class="details-header">
                                        <h2>My Views</h2>
                                        <div class="header-actions">
                                            <!-- <button [attr.guide]="'lead-detail-panel-btn-82' + '__' + sanitizedUrl" class="btn-secondary">View field edit history</button> -->
                                            <button [attr.guide]="'lead-detail-panel-btn-83' + '__' + sanitizedUrl"
                                                (click)="manageFields()" class="btn-secondary">Manage fields</button>
                                        </div>
                                    </div>

                                    <div class="details-tabs">
                                        <button [attr.guide]="'lead-detail-panel-btn-84' + '__' + sanitizedUrl"
                                            [class.active]="activeViewNew === 'basic'"
                                            (click)="setViewNew('basic')">Lead
                                            information</button>
                                        <button [attr.guide]="'lead-detail-panel-btn-85' + '__' + sanitizedUrl"
                                            [class.active]="activeViewNew === 'Original'"
                                            (click)="setViewNew('Original')">
                                            Original Lead Format</button>

                                    </div>

                                    <div class="details-content">
                                        <div *ngIf="activeViewNew === 'Original'">

                                            <div class="content-section">

                                                <ng-container
                                                    *ngIf="jsonRecieved && (jsonRecieved | keyvalue).length > 0; else noRecord">
                                                    <div>
                                                        <table id="details">
                                                            <tr *ngFor="let item of jsonRecieved | keyvalue">
                                                                <td>
                                                                    {{ item.key === 'adGroupName' ? 'Campaign Name' :
                                                                    item.key
                                                                    }}
                                                                </td>
                                                                <td>
                                                                    <p *ngIf="item.key!='Lead Status' &&item.key!='Lead Source' &&item.key!='Category' &&item.key!='Product'"
                                                                        class="blackColor wordBreak"
                                                                        [innerHTML]="item.value">
                                                                    </p>

                                                                    <p *ngIf="item.key=='Lead Status'"
                                                                        class="blackColor wordBreak"
                                                                        [innerHTML]="LeadDetailsObject?.statusName">
                                                                    </p>
                                                                    <p *ngIf="item.key=='Lead Source'"
                                                                        class="blackColor wordBreak"
                                                                        [innerHTML]="LeadDetailsObject?.sourceName">
                                                                    </p>
                                                                    <p *ngIf="item.key=='Category'"
                                                                        class="blackColor wordBreak"
                                                                        [innerHTML]="LeadDetailsObject?.category"> </p>
                                                                    <p *ngIf="item.key=='Product'"
                                                                        class="blackColor wordBreak"
                                                                        [innerHTML]="LeadDetailsObject?.product"> </p>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </ng-container>
                                                <ng-template #noRecord>
                                                    <div class="text-center text-muted py-4">
                                                        <p>No data found.</p>
                                                    </div>
                                                </ng-template>

                                            </div>

                                        </div>

                                        <div *ngIf="activeViewNew === 'basic'">


                                            <div class="content-section" *ngIf="manageFieldCustomization == 0">

                                                <ng-container>
                                                    <div>

                                                        <table
                                                            *ngIf="leadCommonPropertiesDisplay==1 && usedInSite!=null&&(usedInSite | keyvalue)?.length> 0">

                                                            <tr>
                                                                <th colspan="2">
                                                                    {{leadCommonPropertiesName}}
                                                                </th>
                                                            </tr>
                                                            <ng-container *ngIf="!type3">

                                                                <tr *ngFor="let item of usedInSite | keyvalue">
                                                                    <td>
                                                                        {{item.key}}
                                                                    </td>
                                                                    <td>
                                                                        <p *ngIf="item.key!='Lead Status' &&item.key!='Lead Source' &&item.key!='Category' &&item.key!='Product'"
                                                                            class="blackColor wordBreak"
                                                                            [innerHTML]="item.value"> </p>

                                                                        <p *ngIf="item.key=='Lead Status'"
                                                                            class="blackColor wordBreak"
                                                                            [innerHTML]="LeadDetailsObject?.statusName">
                                                                        </p>
                                                                        <p *ngIf="item.key=='Lead Source'"
                                                                            class="blackColor wordBreak"
                                                                            [innerHTML]="LeadDetailsObject?.sourceName">
                                                                        </p>
                                                                        <p *ngIf="item.key=='Category'"
                                                                            class="blackColor wordBreak"
                                                                            [innerHTML]="LeadDetailsObject?.category">
                                                                        </p>
                                                                        <p *ngIf="item.key=='Product'"
                                                                            class="blackColor wordBreak"
                                                                            [innerHTML]="LeadDetailsObject?.product">
                                                                        </p>
                                                                    </td>
                                                                </tr>

                                                            </ng-container>
                                                            <ng-container *ngIf="type3">

                                                                <tr *ngFor="let item of customList ">


                                                                    <td>
                                                                        {{item[0]}}
                                                                    </td>
                                                                    <td>
                                                                        <p *ngIf="item[0]!='Lead Status' &&item[0]!='Lead Source' &&item[0]!='Category' &&item[0]!='Product'"
                                                                            class="blackColor wordBreak"
                                                                            [innerHTML]="item[1]"> </p>


                                                                        <p *ngIf="item[0]=='Lead Status'"
                                                                            class="blackColor wordBreak"
                                                                            [innerHTML]="LeadDetailsObject?.statusName">
                                                                        </p>
                                                                        <p *ngIf="item[0]=='Lead Source'"
                                                                            class="blackColor wordBreak"
                                                                            [innerHTML]="LeadDetailsObject?.sourceName">
                                                                        </p>
                                                                        <p *ngIf="item[0]=='Category'"
                                                                            class="blackColor wordBreak"
                                                                            [innerHTML]="LeadDetailsObject?.category">
                                                                        </p>
                                                                        <p *ngIf="item[0]=='Product'"
                                                                            class="blackColor wordBreak"
                                                                            [innerHTML]="LeadDetailsObject?.product">
                                                                        </p>

                                                                    </td>
                                                                </tr>

                                                            </ng-container>
                                                        </table>

                                                        <!-- spacing between consecutive tables is handled by CSS; removed <br> -->

                                                        <table
                                                            *ngIf="leadPropertiesDisplay==1 && filterList!=null&&(filterList | keyvalue)?.length> 0">

                                                            <tr>
                                                                <th colspan="2">
                                                                    {{leadPropertiesName}}
                                                                </th>
                                                            </tr>


                                                            <ng-container *ngIf="!type2">

                                                                <tr *ngFor="let item of valuesList | keyvalue">
                                                                    <td>
                                                                        {{item.key}}
                                                                    </td>
                                                                    <td>

                                                                        <p *ngIf="item.key!='Lead Status' &&item.key!='Lead Source' &&item.key!='Category' &&item.key!='Product'"
                                                                            class="blackColor wordBreak"
                                                                            [innerHTML]="item.value"> </p>

                                                                        <p *ngIf="item.key=='Lead Status'"
                                                                            class="blackColor wordBreak"
                                                                            [innerHTML]="LeadDetailsObject?.statusName">
                                                                        </p>
                                                                        <p *ngIf="item.key=='Lead Source'"
                                                                            class="blackColor wordBreak"
                                                                            [innerHTML]="LeadDetailsObject?.sourceName">
                                                                        </p>
                                                                        <p *ngIf="item.key=='Category'"
                                                                            class="blackColor wordBreak"
                                                                            [innerHTML]="LeadDetailsObject?.category">
                                                                        </p>
                                                                        <p *ngIf="item.key=='Product'"
                                                                            class="blackColor wordBreak"
                                                                            [innerHTML]="LeadDetailsObject?.product">
                                                                        </p>
                                                                    </td>

                                                                </tr>

                                                            </ng-container>
                                                            <ng-container *ngIf="type2">

                                                                <tr *ngFor="let item of filterList | keyvalue">


                                                                    <td>
                                                                        {{item.key}}
                                                                    </td>
                                                                    <td>
                                                                        <p *ngIf="item.key!='Lead Status' &&item.key!='Lead Source' &&item.key!='Category' &&item.key!='Product'"
                                                                            class="blackColor wordBreak"
                                                                            [innerHTML]="item.value"> </p>

                                                                        <p *ngIf="item.key=='Lead Status'"
                                                                            class="blackColor wordBreak"
                                                                            [innerHTML]="LeadDetailsObject?.statusName">
                                                                        </p>
                                                                        <p *ngIf="item.key=='Lead Source'"
                                                                            class="blackColor wordBreak"
                                                                            [innerHTML]="LeadDetailsObject?.sourceName">
                                                                        </p>
                                                                        <p *ngIf="item.key=='Category'"
                                                                            class="blackColor wordBreak"
                                                                            [innerHTML]="LeadDetailsObject?.category">
                                                                        </p>
                                                                        <p *ngIf="item.key=='Product'"
                                                                            class="blackColor wordBreak"
                                                                            [innerHTML]="LeadDetailsObject?.product">
                                                                        </p>
                                                                    </td>
                                                                </tr>

                                                            </ng-container>

                                                        </table>

                                                        <!-- spacing between consecutive tables is handled by CSS; removed <br> -->

                                                        <table
                                                            *ngIf="leadAdditionalPropertiesDisplay==1 && additionalSpec!=null&&(additionalSpec | keyvalue)?.length> 0">

                                                            <tr>
                                                                <th colspan="2">
                                                                    {{leadAdditionalPropertiesName}}
                                                                </th>
                                                            </tr>


                                                            <ng-container *ngIf="!type1">

                                                                <tr *ngFor="let item of additionalSpec | keyvalue">
                                                                    <td>
                                                                        {{item.key}}
                                                                    </td>
                                                                    <td>
                                                                        <p *ngIf="item.key!='Lead Status' &&item.key!='Lead Source' &&item.key!='Category' &&item.key!='Product'"
                                                                            class="blackColor wordBreak"
                                                                            [innerHTML]="item.value"> </p>

                                                                        <p *ngIf="item.key=='Lead Status'"
                                                                            class="blackColor wordBreak"
                                                                            [innerHTML]="LeadDetailsObject?.statusName">
                                                                        </p>
                                                                        <p *ngIf="item.key=='Lead Source'"
                                                                            class="blackColor wordBreak"
                                                                            [innerHTML]="LeadDetailsObject?.sourceName">
                                                                        </p>
                                                                        <p *ngIf="item.key=='Category'"
                                                                            class="blackColor wordBreak"
                                                                            [innerHTML]="LeadDetailsObject?.category">
                                                                        </p>
                                                                        <p *ngIf="item.key=='Product'"
                                                                            class="blackColor wordBreak"
                                                                            [innerHTML]="LeadDetailsObject?.product">
                                                                        </p>
                                                                    </td>
                                                                </tr>

                                                            </ng-container>

                                                            <ng-container *ngIf="type1">

                                                                <tr *ngFor="let item of additionalSpecList ">


                                                                    <td>
                                                                        {{item[0]}}
                                                                    </td>
                                                                    <td>
                                                                        <p *ngIf="item[0]!='Lead Status' &&item[0]!='Lead Source' &&item[0]!='Category' &&item[0]!='Product'"
                                                                            class="blackColor wordBreak"
                                                                            [innerHTML]="item[1]"> </p>

                                                                        <p *ngIf="item[0]=='Lead Status'"
                                                                            class="blackColor wordBreak"
                                                                            [innerHTML]="LeadDetailsObject?.statusName">
                                                                        </p>
                                                                        <p *ngIf="item[0]=='Lead Source'"
                                                                            class="blackColor wordBreak"
                                                                            [innerHTML]="LeadDetailsObject?.sourceName">
                                                                        </p>
                                                                        <p *ngIf="item[0]=='Category'"
                                                                            class="blackColor wordBreak"
                                                                            [innerHTML]="LeadDetailsObject?.category">
                                                                        </p>
                                                                        <p *ngIf="item[0]=='Product'"
                                                                            class="blackColor wordBreak"
                                                                            [innerHTML]="LeadDetailsObject?.product">
                                                                        </p>
                                                                    </td>
                                                                </tr>

                                                            </ng-container>


                                                        </table>

                                                    </div>
                                                </ng-container>
                                                <ng-template #noRecord>
                                                    <div class="text-center text-muted py-4">
                                                        <p>No data found.</p>
                                                    </div>
                                                </ng-template>

                                            </div>

                                            <div class="content-section" *ngIf="manageFieldCustomization == 1">


                                                <div class="content-section" *ngFor="let group of mappedGroups">
                                                    <div class="section-header">
                                                        <h3>{{ group.groupName }}</h3>
                                                    </div>

                                                    <div class="section-body">
                                                        <div class="details-grid-4col">

                                                            <div class="info-item" *ngFor="let field of group.fields">

                                                                <label>{{ field.fieldName }}</label>

                                                                <div class="value-display">
                                                                    <ng-container [ngSwitch]="field.fieldKey">

                                                                        <a [attr.guide]="'lead-detail-panel-lnk-86' + '__' + sanitizedUrl"
                                                                            *ngSwitchCase="'Email'"
                                                                            (click)="field.value !== '-' ? openEmailPopup() : null">
                                                                            {{ field.value }}
                                                                        </a>


                                                                        <span *ngSwitchDefault>
                                                                            {{ field.value }}
                                                                        </span>

                                                                    </ng-container>

                                                                    <button
                                                                        [attr.guide]="'lead-detail-panel-btn-87' + '__' + sanitizedUrl"
                                                                        *ngIf="!field.isReadOnly"
                                                                        (click)="openEditPopupNew(field.fieldKey, field.fieldName, field.fieldType, field)"
                                                                        class="edit-btn">
                                                                        <mat-icon>edit</mat-icon>
                                                                    </button>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>


                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngSwitchCase="'Activities'">
                                <div class="card activities-new-type">
                                    <div class="activity-container">

                                        <div class="tabs">
                                            <!-- Desktop / wide screens: horizontal tabs -->
                                            <ul class="tabs-list">
                                                <li [ngClass]="{'active': activeTabInner === 'activity'}"
                                                    (click)="selectTabInner('activity')">Activity timeline</li>
                                                <li [ngClass]="{'active': activeTabInner === 'notes'}"
                                                    (click)="selectTabInner('notes')">Notes</li>
                                                <li [ngClass]="{'active': activeTabInner === 'tasks'}"
                                                    *ngIf="!url.includes('deals') && !url.includes('type=deal')"
                                                    (click)="selectTabInner('tasks')">Tasks</li>
                                                <li [ngClass]="{'active': activeTabInner === 'meetings'}"
                                                    *ngIf="!url.includes('deals') && !url.includes('type=deal')"
                                                    (click)="selectTabInner('meetings')">Meetings</li>
                                                <li [ngClass]="{'active': activeTabInner === 'Chats'}"
                                                    *ngIf="!url.includes('deals') && !url.includes('type=deal')"
                                                    (click)="selectTabInner('Chats')">Chats</li>
                                                <li [ngClass]="{'active': activeTabInner === 'Email Sent'}"
                                                    *ngIf="!url.includes('deals') && !url.includes('type=deal')"
                                                    (click)="selectTabInner('Email Sent')">Email</li>
                                                <li [ngClass]="{'active': activeTabInner === 'Calls'}"
                                                    *ngIf="!url.includes('deals') && !url.includes('type=deal')"
                                                    (click)="selectTabInner('Calls')">Calls</li>
                                                <li [ngClass]="{'active': activeTabInner === 'Email Status'}"
                                                    *ngIf="!url.includes('deals') && !url.includes('type=deal')"
                                                    (click)="selectTabInner('Email Status')">Email Status</li>
                                            </ul>

                                            <!-- Mobile / narrow screens: compact select -->
                                            <mat-form-field appearance="outline" class="tabs-select">
                                                <mat-select [value]="activeTabInner"
                                                    (selectionChange)="selectTabInner($event.value)">
                                                    <mat-option value="activity">Activity timeline</mat-option>
                                                    <mat-option value="notes">Notes</mat-option>
                                                    <mat-option value="tasks"
                                                        *ngIf="!url.includes('deals') && !url.includes('type=deal')">Tasks</mat-option>
                                                    <mat-option value="meetings"
                                                        *ngIf="!url.includes('deals') && !url.includes('type=deal')">Meetings</mat-option>
                                                    <mat-option value="Chats"
                                                        *ngIf="!url.includes('deals') && !url.includes('type=deal')">Chats</mat-option>
                                                    <mat-option value="Email Sent"
                                                        *ngIf="!url.includes('deals') && !url.includes('type=deal')">Email</mat-option>
                                                    <mat-option value="Calls"
                                                        *ngIf="!url.includes('deals') && !url.includes('type=deal')">Calls</mat-option>
                                                    <mat-option value="Email Status"
                                                        *ngIf="!url.includes('deals') && !url.includes('type=deal')">Email
                                                        Status</mat-option>
                                                </mat-select>
                                            </mat-form-field>

                                            <!-- <button [attr.guide]="'lead-detail-panel-btn-88' + '__' + sanitizedUrl" class="create-custom-activity-btn">+ Create custom sales activity</button> -->
                                        </div>

                                        <!-- <div class="filters">
                                    <span>Filter by:</span>
                                    <button [attr.guide]="'lead-detail-panel-btn-89' + '__' + sanitizedUrl" class="filter-btn">All activities ▼</button>
                                    <button [attr.guide]="'lead-detail-panel-btn-90' + '__' + sanitizedUrl" class="filter-btn">All time periods ▼</button>
                                </div> -->

                                        <div *ngIf="activeTabInner === 'activity'" class="timeline">

                                            <ng-container *ngIf="init && activityHistoryType == 1">
                                                <calsoft-activity (scrollChange)="onScroll()" [spinner]="spinner"
                                                    [onScrollValue]="onScrollValue"
                                                    [leadActivityListFinal]="leadActivityListFinal"
                                                    [totalSize]="totalSize" [leadid]="leadId" fxFlex
                                                    [leadActivityList]="leadActivityList">
                                                </calsoft-activity>
                                            </ng-container>

                                            <ng-container *ngIf="activityHistoryType == 0">
                                                <calsoft-activity-new [type]="1" [spinner]="spinner"
                                                    [onScrollValue]="onScrollValue"
                                                    [groupedActivities]="groupedActivities"
                                                    (scrollChange)="onScrollNew()"></calsoft-activity-new>
                                            </ng-container>

                                        </div>
                                        <div *ngIf="activeTabInner === 'notes'" class="notes-view-container">

                                            <div class="notes-header">
                                                <h2>Notes</h2>
                                                <button [attr.guide]="'lead-detail-panel-btn-91' + '__' + sanitizedUrl"
                                                    class="add-note-btn" (click)="createNote(null, 0)">
                                                    <span class="material-icons-outlined">add</span>
                                                    Add note
                                                </button>
                                            </div>

                                            <div *ngIf="noteList && noteList.length > 0; else emptyState"
                                                class="notes-list">
                                                <div *ngFor="let note of noteList" class="note-card">

                                                    <div class="note-content"
                                                        [innerHTML]="note.notes | mentionHighlight"></div>

                                                    <div class="note-meta">
                                                        <span class="material-icons-outlined edit-icon"
                                                            (click)="createNote(note, note.noteId)">edit</span>
                                                        <span class="author">{{ note.createdBy }}</span>
                                                        <span class="dot">•</span>
                                                        <span class="timestamp">{{ getRelativeTime(note.createdDate)
                                                            }}</span>
                                                    </div>
                                                </div>
                                            </div>

                                            <ng-template #emptyState>
                                                <div class="empty-notes">
                                                    <span class="material-icons-outlined empty-icon">description</span>
                                                    <p>Use notes to capture talking points, action items, and ideas.</p>
                                                    <button
                                                        [attr.guide]="'lead-detail-panel-btn-92' + '__' + sanitizedUrl"
                                                        class="add-note-btn empty-bg-color"
                                                        (click)="createNote(null, 0)">Add note</button>
                                                </div>
                                            </ng-template>
                                        </div>
                                        <div *ngIf="activeTabInner === 'tasks'" class="tasks-view-container">

                                            <div class="tasks-header">
                                                <div class="task-filters">
                                                    <div class="filter-card" [class.active]="activeTaskFilter === 'all'"
                                                        (click)="setTaskFilter('all')">
                                                        <span>All</span>
                                                        <span class="count">{{ totalActivity }}</span>
                                                    </div>
                                                    <div class="filter-card"
                                                        [class.active]="activeTaskFilter === 'upcoming'"
                                                        (click)="setTaskFilter('upcoming')">
                                                        <span>Upcoming</span>
                                                        <span class="count">{{totalActivityUpComing }}</span>
                                                    </div>
                                                    <div class="filter-card"
                                                        [class.active]="activeTaskFilter === 'overdue'"
                                                        (click)="setTaskFilter('overdue')">
                                                        <span>Overdue</span>
                                                        <span class="count overdue-count">{{totalActivityDue }}</span>
                                                    </div>
                                                    <div class="filter-card"
                                                        [class.active]="activeTaskFilter === 'completed'"
                                                        (click)="setTaskFilter('completed')">
                                                        <span>Completed</span>
                                                        <span class="count">{{ totalActivityCompleted }}</span>
                                                    </div>
                                                </div>
                                                <div class="task-actions">

                                                    <button
                                                        [attr.guide]="'lead-detail-panel-btn-93' + '__' + sanitizedUrl"
                                                        class="add-task-btn" [matMenuTriggerFor]="menu">
                                                        <span class="material-icons-outlined">add</span>
                                                        Add task
                                                    </button>

                                                    <mat-menu #menu="matMenu">
                                                        <button
                                                            [attr.guide]="'lead-detail-panel-btn-94' + '__' + sanitizedUrl"
                                                            *ngIf="crmType != 2" mat-menu-item
                                                            (click)="addLeadActivity('Follow Up', 0, null)">
                                                            Follow Up
                                                        </button>
                                                        <button
                                                            [attr.guide]="'lead-detail-panel-btn-95' + '__' + sanitizedUrl"
                                                            mat-menu-item
                                                            (click)="addLeadActivity('Phone Call', 0, null)">
                                                            Phone Call
                                                        </button>
                                                        <button
                                                            [attr.guide]="'lead-detail-panel-btn-96' + '__' + sanitizedUrl"
                                                            mat-menu-item
                                                            (click)="addLeadActivityone('Location', 0, null)">
                                                            Location
                                                        </button>
                                                    </mat-menu>

                                                </div>
                                            </div>

                                            <div *ngIf="activeTaskFilter === 'all'">
                                                <calsoft-task-new (scrollChange)="onScroll()" (taskUpdated)="onTaskUpdated()" [type]="1"
                                                    [onScrollValue]="onScrollValue" [taskType]="taskType"
                                                    [templateDisplayed]="templateDisplayed" [crmType]="crmType"
                                                    [leadActivityListFinal]="leadActivityListFinalTasks"
                                                    [totalSize]="totalSize-1" [page]="pagetwo" [total]="total"
                                                    [entityId]="leadId" [spinner]="spinner"
                                                    [activityList]="leadActivityListTasks"></calsoft-task-new>
                                            </div>


                                            <div *ngIf="activeTaskFilter === 'upcoming'">
                                                <calsoft-task-new (scrollChange)="onScrollUpcoming()" (taskUpdated)="onTaskUpdated()" [type]="1"
                                                    [onScrollValue]="onScrollValueUpcoming" [taskType]="taskType"
                                                    [templateDisplayed]="templateDisplayed" [crmType]="crmType"
                                                    [leadActivityListFinal]="leadActivityListFinalUpcoming"
                                                    [totalSize]="totalSizeUpcoming-1" [page]="pagetwoUpcoming"
                                                    [total]="totalUpcoming" [entityId]="leadId" [spinner]="spinner"
                                                    [activityList]="leadActivityListUpcoming"></calsoft-task-new>
                                            </div>


                                            <div *ngIf="activeTaskFilter === 'overdue'">
                                                <calsoft-task-new (scrollChange)="onScrollUpDue()" (taskUpdated)="onTaskUpdated()" [type]="1"
                                                    [onScrollValue]="onScrollValue" [taskType]="taskType"
                                                    [templateDisplayed]="templateDisplayed" [crmType]="crmType"
                                                    [totalSize]="totalSizeDue-1" [page]="pagetwoDue"
                                                    [leadActivityListFinal]="leadActivityListDueFinal"
                                                    [total]="totalDue" [entityId]="leadId" [spinner]="spinner"
                                                    [activityList]="leadActivityListDue"></calsoft-task-new>
                                            </div>


                                            <div *ngIf="activeTaskFilter === 'completed'">
                                                <calsoft-task-new (scrollChange)="onScrollUpCompleted()" (taskUpdated)="onTaskUpdated()" [type]="1"
                                                    [onScrollValue]="onScrollValue" [taskType]="taskType"
                                                    [totalSize]="totalSizeDue-1" [page]="pagetwoCompleted"
                                                    [templateDisplayed]="templateDisplayed" [crmType]="crmType"
                                                    [leadActivityListFinal]="leadActivityListFinalCompleted"
                                                    [total]="totalSizeCompleted" [entityId]="leadId" [spinner]="spinner"
                                                    [activityList]="leadActivityListCompleted"></calsoft-task-new>
                                            </div>

                                        </div>
                                        <div *ngIf="activeTabInner === 'meetings'">
                                            <calsoft-leadsmeeting [leadId]="leadId" [meetingType]="1"
                                                [type]="1"></calsoft-leadsmeeting>
                                        </div>

                                        <div *ngIf="activeTabInner === 'Chats'">
                                            <div *ngIf="leadLoaded">
                                                <calsoft-whatsapp-chat-details
                                                    [contactId]="LeadDetailsObject?.phoneNumber" [isFromPhone]="true">
                                                </calsoft-whatsapp-chat-details>
                                            </div>
                                        </div>

                                        <div *ngIf="activeTabInner === 'Email Sent'">
                                            <div class="mailbox-container">

                                                <div class="mailbox-toggle-container">
                                                    <mat-button-toggle-group [(value)]="currentMailBox"
                                                        (change)="loadEmails($event)">
                                                        <mat-button-toggle (click)="loadEmails({ value: 'INBOX' })"
                                                            value="INBOX">Inbox
                                                        </mat-button-toggle>
                                                        <mat-button-toggle (click)="loadEmails({ value: 'Sent' })"
                                                            value="Sent">Sent
                                                        </mat-button-toggle>
                                                    </mat-button-toggle-group>
                                                </div>


                                                <div class="mailbox-content">

                                                    <div class="mailbox-email-list" [class.full-width]="!selectedIndex">
                                                        <ng-container *ngIf="isLoading; else emailListTemplate">
                                                            <div class="loading-spinner">
                                                                <mat-spinner diameter="40"></mat-spinner>
                                                                <p>Loading emails...</p>
                                                            </div>
                                                        </ng-container>
                                                        <ng-template #emailListTemplate>
                                                            <mat-paginator [length]="totalEmails"
                                                                [pageSize]="pageSizeEmail" [pageIndex]="pageIndex"
                                                                (page)="onPageChange($event)">
                                                            </mat-paginator>

                                                            <mat-nav-list>
                                                                <mat-list-item
                                                                    *ngFor="let email of emails; let i = index"
                                                                    [ngClass]="{
                                                    'mailbox-email-list-item': true,
                                                    'active': i === selectedIndex
                                                    }" (click)="selectEmail(i)">
                                                                    <div class="mailbox-email-list-item">
                                                                        <div class="mailbox-email-header">
                                                                            <span class="mailbox-email-subject">{{
                                                                                email.subject }}</span>
                                                                            <span class="mailbox-email-date">{{
                                                                                email.sentDate |
                                                                                date:'medium'
                                                                                }}</span>
                                                                        </div>
                                                                        <div class="mailbox-email-preview">
                                                                            <span class="mailbox-email-from-to">
                                                                                {{ currentMailBox === 'INBOX' ?
                                                                                extractEmailAddress(email.from)
                                                                                : email.to }}
                                                                            </span>
                                                                            <span class="mailbox-email-body-preview">
                                                                                {{ truncateSafeHTML(email.body, 150) }}
                                                                            </span>


                                                                        </div>
                                                                    </div>
                                                                </mat-list-item>
                                                            </mat-nav-list>
                                                        </ng-template>

                                                    </div>



                                                    <div *ngIf="emailVisble; else placeholder"
                                                        class="mailbox-email-wrapper">

                                                        <div class="mailbox-email-detail"
                                                            [ngClass]="{ 'show-detail': isMobileView }">
                                                            <button
                                                                [attr.guide]="'lead-detail-panel-btn-97' + '__' + sanitizedUrl"
                                                                class="back-button" *ngIf="isMobileView"
                                                                (click)="backToList()">
                                                                ← Back
                                                            </button>
                                                            <div class="mailbox-email-detail-header">
                                                                <h2>{{ emailObject.subject }}</h2>
                                                                <div class="mailbox-email-meta">
                                                                    <!-- <div><strong>From:</strong> {{ emailObject.from[0].address }}
                                                </div> -->
                                                                    <div><strong>To:</strong> {{ emailObject.to }}</div>
                                                                    <div><strong>Date:</strong> {{ emailObject.sentDate
                                                                        |
                                                                        date:'medium' }}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="mailbox-email-body"
                                                                [innerHTML]="emailObject.body">
                                                            </div>
                                                            <div class="mailbox-email-attachments"
                                                                *ngIf="emails[selectedIndex]?.attachments?.length > 0">
                                                                <h4>Attachments</h4>
                                                                <ul>
                                                                    <li
                                                                        *ngFor="let file of emails[selectedIndex].attachments">
                                                                        <div *ngIf="isImage(file.contentType)">

                                                                            <img [src]="newserverpath + file.fileName"
                                                                                [alt]="file.fileName"
                                                                                style="height: 50px; width: 100%">

                                                                            <calsoft-common-images
                                                                                [src]="serverPathEmail + file.fileName"
                                                                                [height]="'50px'" [width]="'auto'"
                                                                                [alt]="file.fileName">
                                                                            </calsoft-common-images>
                                                                        </div>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>


                                                    </div>


                                                    <ng-template #placeholder>
                                                        <div class="mailbox-placeholder">
                                                            <mat-icon style="overflow: hidden;">drafts</mat-icon>
                                                            <h3>Select an email to read</h3>
                                                            <p>Choose a message from your Mails to view it here</p>
                                                        </div>
                                                    </ng-template>
                                                </div>

                                                <ng-template #loading>
                                                    <div class="global-loading">
                                                        <mat-spinner></mat-spinner>
                                                        <p>Fetching emails...</p>
                                                    </div>
                                                </ng-template>
                                                <ng-template #emptyState>
                                                    <div class="empty-state">
                                                        <div class="empty-icon">📭</div>
                                                        <h3>No emails found</h3>
                                                        <p>Your folder is empty</p>
                                                    </div>
                                                </ng-template>
                                            </div>
                                        </div>

                                        <div *ngIf="activeTabInner === 'Calls'">
                                            <div class="call-section-bg">
                                                <div class="tab-pane fade" id="calls">
                                                    <div class="card">
                                                        <div
                                                            class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                                                            <h4 class="fw-semibold">Calls</h4>

                                                            <!-- <button [attr.guide]="'lead-detail-panel-btn-98' + '__' + sanitizedUrl" mat-button class="matcss" [matMenuTriggerFor]="menu">
                                    <mat-icon class="icon-css">assignment</mat-icon>
                                    <span style="font-size: 13px;color: gray;">Task</span>
                                </button> -->

                                                            <mat-menu #menu="matMenu">
                                                                <button
                                                                    [attr.guide]="'lead-detail-panel-btn-99' + '__' + sanitizedUrl"
                                                                    *ngIf="crmType!=2" mat-menu-item
                                                                    (click)="addLeadActivityone('Follow Up',0,null)">Follow
                                                                    Up
                                                                </button>
                                                                <button
                                                                    [attr.guide]="'lead-detail-panel-btn-100' + '__' + sanitizedUrl"
                                                                    mat-menu-item
                                                                    (click)="addLeadActivityone('Phone Call',0,null)">Phone
                                                                    Call</button>
                                                                <button
                                                                    [attr.guide]="'lead-detail-panel-btn-101' + '__' + sanitizedUrl"
                                                                    mat-menu-item
                                                                    (click)="addLeadActivityone('Location',0,null)">Location</button>
                                                            </mat-menu>
                                                        </div>
                                                        <div class="card-body"
                                                            *ngIf="calllist?.length > 0; else noData">
                                                            <div class="card mb-3" *ngFor="let lead of calllist;">

                                                                <div class="card-body">
                                                                    <div
                                                                        class="d-sm-flex align-items-center justify-content-between pb-2">
                                                                        <div class="d-flex align-items-center mb-2">
                                                                            <span class="avatar-md me-2 flex-shrink-0">
                                                                                <mat-icon
                                                                                    class="default-icon">person</mat-icon>
                                                                            </span>
                                                                            <p class="m-0"><span
                                                                                    class="text-dark fw-medium">{{lead.customerName}}</span>
                                                                                logged a call on {{lead.updatedDate}}
                                                                            </p>
                                                                        </div>
                                                                        <div
                                                                            class="d-inline-flex align-items-center mb-2">
                                                                            <div class="dropdown me-2">
                                                                                <a href="javascript:void(0);"
                                                                                    class="py-1" [ngClass]="{
                                                                'bg-success be-9': lead.phoneCallOutcome === 'completed' || lead.phoneCallOutcome === 'Answered',
                                                                'bg-danger be-9': lead.phoneCallOutcome === 'failed',
                                                                'bg-warning be-9': lead.phoneCallOutcome === 'call Not Answered'
                                                            }" data-bs-toggle="dropdown" aria-expanded="false">
                                                                                    {{lead.phoneCallOutcome |
                                                                                    titlecase}}
                                                                                    <i
                                                                                        class="ti ti-chevron-down ms-2"></i>
                                                                                </a>


                                                                            </div>
                                                                            <div class="dropdown">
                                                                                <a href="javascript:void(0);"
                                                                                    class="p-0 btn btn-icon btn-sm d-flex align-items-center justify-content-center"
                                                                                    data-bs-toggle="dropdown"
                                                                                    aria-expanded="false"><i
                                                                                        class="ti ti-dots-vertical"></i></a>
                                                                                <div
                                                                                    class="dropdown-menu dropdown-menu-right">
                                                                                    <a class="dropdown-item"
                                                                                        href="javascript:void(0);"><i
                                                                                            class="ti ti-edit text-blue me-1"></i>Edit</a>
                                                                                    <a class="dropdown-item"
                                                                                        href="javascript:void(0);"><i
                                                                                            class="ti ti-trash text-danger me-1"></i>Delete</a>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <span [innerHTML]="lead.notes"> </span>
                                                                </div>
                                                            </div>

                                                        </div>

                                                        <ng-template #noData>
                                                            <div class="text-center text-muted py-4">
                                                                <p>No data found.</p>
                                                            </div>
                                                        </ng-template>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div *ngIf="activeTabInner === 'Email Status'">

                                            <div class="width-table2">
                                                <calsoft-send-all-email [leadId]="leadId" [type]="1">
                                                </calsoft-send-all-email>
                                            </div>


                                        </div>

                                        <div *ngIf="activeTabInner === 'Inbound Emails'">

                                            <div class="width-table2">
                                                <calsoft-inbound-emails [leadObject]="LeadDetailsObject"
                                                    [leadId]="leadId" [type]="1">
                                                </calsoft-inbound-emails>
                                            </div>


                                        </div>
                                        <!-- 
                                    <div *ngIf="activeTabInner === 'Email Status'">

                                     

                                    </div> -->


                                    </div>
                                </div>
                            </div>
                            <div *ngSwitchCase="'Company'">
                                <div class="deal-page1">
                                    <calsoft-account-companies-table [type]="1" [defaultSet]="defaultSet"
                                        [defaultSetType]="defaultSetType"
                                        [leadId]="relatedCompanyId"></calsoft-account-companies-table>
                                </div>
                            </div>
                            <div *ngSwitchCase="'Deals'">

                                <div class="deal-page1">
                                    <calsoft-deal-table [type]="2" [dealsPrimaryType]="0" [DealType]="2"
                                        [data]="LeadDetailsObject" [defaultSet]="defaultSet"
                                        [defaultSetType]="defaultSetType" [leadId]="leadId"
                                        [dealsTableView]="1"></calsoft-deal-table>
                                </div>
                            </div>
                            <!-- <div *ngSwitchCase="'Freddy AI insights'">
                        <div class="card">Freddy AI insights Content</div>
                    </div> -->

                            <div *ngSwitchCase="'Files'">
                                <div class="card">
                                    <div class="padding-10" style="width: 100%;">

                                        <div class="editSets1">
                                            <div class="title " fxLayout="row" fxLayoutAlign="space-between center">
                                                <span>Files</span>

                                                <button [attr.guide]="'lead-detail-panel-btn-102' + '__' + sanitizedUrl"
                                                    mat-icon-button>
                                                    <mat-icon (click)="createFile(null,0)">
                                                        add
                                                    </mat-icon>
                                                </button>
                                            </div>
                                        </div>

                                        <div>
                                            <table>
                                                <tr>
                                                    <th>Name</th>
                                                    <th>Owner</th>
                                                    <th>File Type</th>
                                                    <th>Added On</th>
                                                    <!-- <th>Tags</th> -->
                                                    <th>Download</th>
                                                    <th>Action</th>
                                                </tr>
                                                <tr *ngFor="let note of noteList;">
                                                    <ng-container
                                                        *ngIf="note.notesDocument && note.notesDocument.length > 0">

                                                        <td>
                                                            <!-- If Image -->
                                                            <img *ngIf="note.documentType == '4'" width="36" height="36"
                                                                [src]="serverPathNotes + note.notesDocument + cid"
                                                                alt="Uploaded Image">

                                                            <!-- If Vedio -->

                                                            <img *ngIf="note.documentType == '1'"
                                                                src="assets/images/mp4.png" width="36" height="36"
                                                                alt="Vedio File">

                                                            <!-- If Audio -->

                                                            <img *ngIf="note.documentType == '2'"
                                                                src="assets/images/mp3.png" width="36" height="36"
                                                                alt="Audio File">

                                                            <!-- If Pdf -->
                                                            <img *ngIf="note.documentType == '3'"
                                                                src="assets/images/pdf.png" width="36" height="36"
                                                                alt="PDF File">

                                                            <!-- If Word -->
                                                            <img *ngIf="note.documentType == '5' || note.notesDocument?.endsWith('.doc') || note.notesDocument?.endsWith('.docx')"
                                                                src="assets/images/docx.png" width="36" height="36"
                                                                alt="DOCX File">

                                                            <!-- If Excel -->
                                                            <img *ngIf="note.documentType == '6' || note.notesDocument?.endsWith('.xls') || note.notesDocument?.endsWith('.xlsx')"
                                                                src="assets/images/excel.png" width="36" height="36"
                                                                alt="Excel File">

                                                            <!-- {{ note.notesDocument }} -->
                                                        </td>
                                                        <td>{{note.createdBy}}</td>
                                                        <td>{{note.resource}}</td>
                                                        <td>{{note.createdDate | calsoftDate}}</td>
                                                        <!-- <td>{{note.taggedUser}}</td> -->
                                                        <td style="cursor: pointer;"
                                                            (click)="downloadNew(serverPathNotes + note.notesDocument + cid , note.documentType)">
                                                            <mat-icon>download</mat-icon>
                                                        </td>
                                                        <td style="cursor: pointer;" (click)="deleteNote(note)">
                                                            <mat-icon>delete</mat-icon>
                                                        </td>
                                                    </ng-container>

                                                </tr>


                                            </table>

                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div *ngSwitchCase="'Sequences'">
                                <div class="width-table">
                                    <div class="deal-page1">
                                        <calsoft-task-table [type]="2" [leadId]="leadId"></calsoft-task-table>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <div *ngIf="!leadLoaded" style="height: 100vh;" fxLayout="column" fxLayoutAlign="center center">
        <div class="loading-container">
            <span class="loader"></span>
            <p class="loading-text">Your details are loading...</p>
        </div>
    </div>

</div>